module.exports = {
	"no": {
		"moet-core": {
			"select_language": {
				"title": "Velg språk",
				"paragraph": "Dette vil være ditt standardspråk",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Alltid inkludert",
				"kco": {
					"name": {
						"default": "Kasse"
					},
					"description": {
						"default": "Tilby alle våre betalingsmetoder."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Betal nå"
							},
							"description": {
								"default": "Tilby øyeblikkelig betaling med kort eller bankoverføring."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Betal innen 30 dager"
							},
							"description": {
								"default": "Tilby 30 dagers betalingsfrist. Ingen renter."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Finansiering"
							},
							"description": {
								"default": "Tilby betaling over 6–36 måneder.",
								"DE": "Tilby betaling over 6-24 måneder",
								"AT": "Tilby betaling over 6-24 måneder."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Avdrag"
							},
							"description": {
								"default": "Tilby 3 rentefrie avdrag.",
								"GB": "Tilby 3 rentefrie avdrag."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Del det i 4",
								"US": "Avdrag",
								"AU": "Betal i 4"
							},
							"description": {
								"default": "Tilby 4 rentefrie avdrag.",
								"GB": "Tilby 4 rentefrie avdrag."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Betalingsmetoder"
					},
					"description": {
						"default": "Velg blant våre frittstående betalingsløsninger. Velg én, eller kombiner flere. Én enkel integrasjon, uansett hva du velger."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Betal nå"
							},
							"description": {
								"default": "Tilby øyeblikkelig betaling med kort eller bankoverføring."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Betal innen 30 dager"
							},
							"description": {
								"default": "Tilby 30 dagers betalingsfrist. Ingen renter."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Finansiering"
							},
							"description": {
								"default": "Tilby betaling over 6–36 måneder.",
								"DE": "Tilby betaling over 6-24 måneder",
								"AT": "Tilby betaling over 6-24 måneder."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Avdrag"
							},
							"description": {
								"default": "Tilby 3 rentefrie avdrag.",
								"GB": "Tilby 3 rentefrie avdrag."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Del det i 4",
								"US": "4 betalinger",
								"CA": "4 betalinger",
								"AU": "Betal i 4"
							},
							"description": {
								"default": "Tilby 4 rentefrie avdrag.",
								"GB": "Tilby 4 rentefrie avdrag.",
								"US": "Ordre mellom 35 $ og 1000 $ kan deles i 4 rentefrie betalinger som vil forfalle annenhver uke.",
								"CA": "Ordrer fra USD 35 opptil USD 1000 kan fordeles mellom 4 rentefrie betalinger, med betalingsfrist hver 2 uke."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Kasse"
					},
					"description": {
						"default": "Bytt ut utsjekkingen i butikken din med Klarnas komplette utsjekkingstjenester."
					},
					"description_expanded": {
						"default": "Bytt ut utsjekkingen i butikken din med Klarnas komplette utsjekkingstjenester."
					}
				},
				"kp_one": {
					"name": {
						"default": "Betalingsmetode"
					},
					"description": {
						"default": "Legg til Klarna-betalingsmetoder i din eksisterende utsjekking"
					},
					"description_expanded": {
						"default": "Å tilby Klarnas betalingsmetoder fører til en gjennomsnittlig økning på 30 % i konvertering, 41 % i AOV og 36 % i kjøpsfrekvens."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Obligatorisk felt for å fortsette",
					"generic": "Oppgitt verdi er ugyldig",
					"required_suffix": "obligatorisk for å fortsette",
					"generic_suffix": "er ugyldig",
					"min_one": "Du må velge minst ett element",
					"min": "Du må velge minst {min} elementer",
					"max": "Du kan ikke velge mer enn {max} elementer",
					"given_name": "Fornavn mangler",
					"family_name": {
						"general": "Etternavn mangler",
						"too_short": "Vennligst oppgi et gyldig etternavn"
					},
					"date_of_birth": {
						"general": {
							"default": "Oppgi en gyldig fødselsdato (DD/MM/ÅÅÅÅ)",
							"US": "Oppgi en gyldig fødselsdato (MM/DD/ÅÅÅÅ)"
						},
						"too_young": "Alle interessenter må være eldre enn 16 år",
						"too_young_eighteen": "Du må være eldre enn 18 år"
					},
					"street_address": "Vennligst oppgi adresse",
					"street_address2": "Oppgi en gyldig adresselinje 2",
					"postal_code": "Vennligst oppgi postnummer",
					"country": "Vennligst oppgi land",
					"region": "Vennligst oppgi region",
					"state": "Oppgi en stat",
					"iban": "Vennligst oppgi kontonummer (IBAN)",
					"companyName": "Vennligst oppgi firmanavn",
					"email": "Vennligst oppgi en gyldig e-postadresse",
					"contact_email": "Oppgi en gyldig e-postadresse",
					"support_email": "Oppgi en gyldig e-post for kundeservice",
					"support_phone": "Oppgi et gyldig telefonnummer til kundeseervice",
					"selling_countries": "Du må velge minst ett land",
					"store_category": "Du må velge ett av alternativene",
					"name": "Vennligst oppgi butikknavn",
					"legal_form": "Velg en av de oppførte virksomhetstypene",
					"generic_toggle_undefined": "Velg ett av alternativene",
					"website": "Vennligst oppgi en gyldig nettsideadresse",
					"bankAccounts": "Vennligst oppgi minst én bankkonto",
					"product": "Vennligst velg produkt",
					"platform": "Vennligst velg plattfrom",
					"password": "Vennligst opprett et sterkt passord",
					"currency_code": "Vennligst oppgi valutakode",
					"account_holder": "Vennligst oppgi bankkontoinnehaver",
					"account_type": "Vennligst oppgi en bankkontotype",
					"routing_number": "Vennligst oppgi gyldig rutingnummer",
					"account_number": {
						"first": "Vennligst oppgi gyldig kontonummer for standard bankkonto",
						"second": "Vennligst oppgi et gyldig kontonummer for den første ekstra bankkontoen",
						"third": "Vennligst oppgi et gyldig kontonummer for den andre ekstra bankkontoen ",
						"fourth": "Vennligst oppgi et gyldig kontonummer for den tredje ekstra bankkontoen ",
						"general": "Vennligst oppgi et gyldig kontonummer"
					},
					"role": "Vennligst oppgi funksjon",
					"address": "Vennligst oppgi adresse",
					"political_exposed_person": "Vennligst oppgi PEP-informasjon",
					"pep_position": "Vennligst oppgi stillingsinformasjon",
					"pep_relationship": "Vennligst oppgi en relasjonsinformasjon til PEP-personen",
					"goodsCategory": "Vennligst oppgi varekategori",
					"registered": "Vennligst oppgi informasjon om din firmaregistrering",
					"subjectToVat": "Vennligst oppgi et MVA-nummer",
					"registrationCourt": "Vennligst oppgi registreringsinstans",
					"registrationId": {
						"general": {
							"default": "Vennligst legg inn gyldig registreringsnummer",
							"AT": "Vennligst legg inn gyldig registreringsnummer",
							"AU": "Oppgi et gyldig ACN",
							"ES": "Skriv inn et gyldig firma-NIF/NIE/DNI",
							"GB": "Oppgi et gyldig organisasjonsnummer",
							"GR": "Angi et gyldig G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"CA": "Oppgi et gyldig bedriftsnummer",
							"NZ": "Vennligst oppgi et gyldig forretningsnummer",
							"US": "Oppgi et gyldig Arbeidsgiversidentifikasjonsnummer"
						},
						"missing_leading_0_GB": "Oppgi et organisasjonsnummer på 8 sifre. Organisasjonsnummeret kan mangle første 0 (f.eks. 03452678)",
						"invalid": {
							"default": "Oppgi et gyldig registreringsnummer",
							"AT": "Registreringsnummeret skal være 5 til 11 tegn langt. Vær oppmerksom på at dette ikke er din MVA eller butikk-ID.",
							"AU": "ACN bør bestå av 9 sifre, uten mellomrom. F.eks.: 123456789",
							"BE": "Registreringsnummeret bør være 10 sifre langt. F.eks.: 1234567890",
							"CA": "Forretningsnummeret må bestå av 9 sifre. F.eks: 123456789",
							"CZ": "Registreringsnummeret må være 8 sifre langt. F.eks: 12345678",
							"DE": "Registreringsnummeret skal inneholde 6 til 11 tegn og må starte med HRA, HRB, GnR, VR eller PR etterfulgt av et mellomrom. Vær oppmerksom på at dette ikke er momsnummeret eller din butikk-ID.",
							"ES": "NIF/NIE/DNI skal bestå av 8 eller 9 tegn, som begynner med 1 bokstav/siffer etterfulgt av 6 eller 7 siffer og 1 bokstav/siffer",
							"FI": "Registreringsnummeret må være 8 sifre langt, med bindestrek før det siste, ingen mellomrom tillatt. F.eks: 1234567-8",
							"FR": "Registreringsnummeret bør bestå av 9 sifre, for eksempel 123 456 789 eller 123456789 (SIREN), eller 14 sifre, f.eks. 123 456 789 12345 eller 12345678912345 (SIRET).",
							"IE": "Registreringsnummer skal være 2 bokstaver etterfulgt av 6 sifre, eller bare 6 sifre hvis du driver et enkeltpersonforetak (f.eks. AB123456).",
							"IT": "Registreringsnummeret skal bestå av 11 sifre (f.eks. 01234567890) eller en kombinasjon av 16 tall og store bokstaver (f.eks. ABCABC12A12A123A)",
							"GB": "Organisasjonsnummeret skal bestå av 8 sifre. F.eks.: 12345678, eller to bokstaver etterfulgt av 6 sifre (SC123456), eller 1 bokstav etterfulgt av 7 sifre (S1234567)",
							"GR": "G.E.MI.-nummer skal være på 12 siffer, f.eks. 012345678901",
							"NL": "Registreringsnummeret må være 8 sifre langt. F.eks: 12345678",
							"NO": "Registreringsnummeret bør være 9 sifre langt, uten mellomrom. F.eks.: 123456789",
							"NZ": "Forretningsnummeret bør bestå av 13 sifre. F.eks: 1234567890123",
							"PL": "Registreringsnummeret skal bestå av 10 sifre uten mellomrom. F.eks: 1234561234",
							"PT": "Registreringsnummeret bør være 9 sifre langt, uten mellomrom. F.eks.: 123123123",
							"SE": "Registreringsnummeret må være 10 siffer langt, med bindestrek, ingen mellomrom tillatt. F.eks: 123456-1234",
							"US": "Arbeidsgivers identifikasjonsnummer bør være 9 sifre med en «-» etter de to første. F.eks.: 12-3456789",
							"MX": "RFC skal bestå av 12 tegn, og begynner med selskapets initialer, den 6-sifrede inkorporeringsdatoen og sjekkverdien. For eksempel: ABC921010H20"
						}
					},
					"tocLink": "Noe gikk galt med vilkårene. Vennligst prøv igjen senere, eller kontakt vår kundeservice på {supportEmail}",
					"vat": {
						"general": {
							"default": "Vennligst oppgi et gyldig MVA-nummer",
							"AU": "Oppgi en gyldig ABN",
							"ES": "Skriv inn et gyldig firma-NIF/NIE/DNI",
							"NZ": "Vennligst oppgi et gyldig GST-nummer"
						},
						"invalid": {
							"default": "Ugyldig momsnummer",
							"AT": "MVA-nummer må være ATU etterfulgt av 8 sifre. F.eks: ATU12345678",
							"AU": "ABN bør bestå av 11 sifre.",
							"CZ": "MVA-nummer skal være CZ etterfulgt av 8, 9 eller 10 sifre. F.eks.: CZ123456789",
							"GR": "MVA-nummer skal bestå av 9 sifre og må begynne med EL. For eksempel: EL123456789",
							"DE": "MVA-nummer må være DE etterfulgt av 9 sifre. F.eks: DE123456789",
							"ES": "NIF/NIE/DNI skal bestå av 8 eller 9 tegn, som begynner med 1 bokstav/siffer etterfulgt av 6 eller 7 siffer og 1 bokstav/siffer",
							"FR": "Mva-nummeret bør være NO etterfulgt av to bokstaver / sifre og 9 sifre (SIREN), f.eks. NOXX123456789",
							"GB": "MVA-nummer må være 6 til 15 tegn langt.",
							"IE": "MVA-nummeret skal være IE etterfulgt av 8 eller 9 tegn som inkluderer 1 eller 2 bokstaver. For eksempel: IE1234567WA, IE1234567A",
							"IT": "MVA-nummer må være TI etterfulgt av 11 sifre. F.eks: IT12345678912",
							"NL": "MVA-nummer må være NL etterfulgt av 9 sifre, etterfulgt av B og 2 sifre. F.eks: NL123456789B12",
							"NZ": "GST-nummeret bør bestå av 8 sifre (12345678) eller 9 sifre, med eller uten bindestrek etter hvert tredje siffer (123-123-123 eller 123123123)",
							"PL": "MVA-nummer skal bestå av PL etterfulgt av 10 sifre. F.eks: PL1234567890",
							"PT": "MVA-nummer skal være PT etterfulgt av 9 sifre. F.eks.: PT123123123",
							"MX": "RFC skal begynner med selskapets initialer, den 6-sifrede inkorporeringsdatoen og sjekkverdien. For eksempel: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Oppgi de 4 siste sifrene i personnummeret",
							"format": "Oppgi de 4 siste sifrene i personnummeret"
						},
						"US_FULL_SSN": {
							"general": "Oppgi det fullstendige SSN-nummeret ditt (9 sifre)",
							"format": "Skriv inn det fullstendige SSN-nummeret ditt (9 sifre)"
						},
						"CA": {
							"general": "Oppgi gyldig SIN- eller passnummer",
							"format": "SIN: XXX-XXX-XXX / Passnummer: ABXXXXXX"
						},
						"SE": {
							"general": "Vennligst oppgi et gyldig personnummer (PNO)",
							"format": "Oppgi PNO i formatet: ÅÅÅÅMMDD-XXXX"
						},
						"FI": {
							"general": "Oppgi et gyldig personnummer (HETU)",
							"format": "Oppgi HETU i formatet: DDMMÅÅSXXXX"
						},
						"NO": {
							"general": "Oppgi et gyldig personnummer",
							"format": "Oppgi i formatet: DDMMÅÅXXXXX"
						},
						"DK": {
							"general": "Oppgi et gyldig personnummer (CPR)",
							"format": "Oppgi CPR i formatet: DDMMÅÅ-XXXX"
						},
						"IT": {
							"general": "Skriv inn en gyldig skattekode",
							"format": "Skriv inn skattekode i formatet: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Skriv inn et gyldig personlig identifikasjonsnummer (DNI eller NIE)",
							"format": "Skriv inn DNI eller NIE, f.eks. 12345678A"
						},
						"PL": {
							"general": "Oppgi et gyldig personnummer (PESEL)",
							"format": "Oppgi PESEL i formatet: ÅÅMMDDZZZXQ"
						},
						"default": {
							"general": "Oppgi gyldig passnummer"
						}
					},
					"store_name": "Vennligst oppgi butikknavn"
				},
				"errors_keys": {
					"correlationIdLabel": "Korrelasjons-ID: {correlationId}",
					"decisionTaken": "Beslutningen om forhåndsvurdering er allerede tatt. Last siden på nytt.",
					"maintenanceMode": "Appen er for tiden nede på grunn av vedlikehold. Kom tilbake senere",
					"validation": {
						"storeName": {
							"invalidType": "Oppgi et gyldig butikknavn."
						},
						"email": {
							"invalidType": "Oppgi en gyldig e-postadresse."
						},
						"goodsCategory": {
							"invalidType": "Oppgi en varekategori."
						},
						"website": {
							"invalidType": "Oppgi et gyldig nettsted."
						}
					}
				}
			},
			"general": {
				"yes": "Ja",
				"no": "Nei",
				"encrypted_text": "*******",
				"pricing_link_eu": "Se alle priser per land",
				"pricing_link_us": "Se priser",
				"formFieldOptional": "valgfritt",
				"buttons": {
					"next": "Neste",
					"back": "Tilbake",
					"continue": "Fortsett",
					"submit_application": {
						"default": "Kom i gang",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Kom i gang"
					},
					"add_aditional_item": "+ Legg til ekstra element"
				},
				"unknown_step_title": "Oppgi obligatorisk informasjon",
				"selected": "Valgt",
				"clear_all": "Fjern alt"
			},
			"errors": {
				"general": "Det har oppstått en feil. Kontakt kundeservice.",
				"salesforce": "Prøv å oppdatere siden. Hvis feilen vedvarer, send feil-ID-en til #smooothforce-support-kanalen, så hjelper vi deg.",
				"managed_kyc": "Prøv å oppdatere siden. Hvis feilen fortsatt vedvarer, kan du kontakte forhandlersupport eller salgskontakten.",
				"copy": "Kopi",
				"noTermsAccepted": "Vennligst les og godta alle våre oppførte avtaler",
				"termsAlreadyAccepted": "Du har allerede godtatt alle de oppførte avtalene",
				"mandatoryField": " kreves"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Eneste forhandler",
					"PARTNERSHIP": "Partnerskap",
					"PUBLIC_LISTED_COMPANY": "Offisielt oppførte selskaper",
					"PRIVATE_COMPANY": "Private selskaper"
				},
				"organization_entity_types": {
					"C_CORP": "C selskap",
					"S_CORP": "S selskap",
					"PARTNERSHIP": "Partnerskap",
					"TRUST_ESTATE": "Trust/eiendom",
					"INDIVIDUAL": "Individuell",
					"SOLE_PROPRIETORSHIP": "Enkeltpersonsforetak",
					"SOLE_TRADER": "Eneste forhandler",
					"LIMITED_LIABILITY_COMPANY": "Aksjeselskap",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Enkeltpersonsaksjeselskap"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Klær og sko: sko og klær til voksne",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Bilprodukter: bildeler og tilbehør",
					"BAGS_AND_WALLETS": "Smykker og tilbehør: vesker og lommebøker",
					"BODY_AND_HAIR_CARE": "Helse og skjønnhet: kropp- og hårpleie",
					"BOOK_AND_MAGAZINES": "Underholdning: bøker og blader",
					"CANDY": "Mat og drikke: godteri",
					"CAR_ELECTRONICS": "Elektronikk: bilelektronikk",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Barneprodukter: barneklær og pleieprodukter",
					"CHILDREN_TOYS": "Barneprodukter: barneleker",
					"CLEANING_AND_SANITARY": "Hjem og hage: rengjøring og sanitær",
					"COLLECTIBLES": "Fritid, sport og hobby: samleobjekter",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Fritid, sport og hobby: konseptbutikker og diverse",
					"COSMETICS": "Helse og skjønnhet: kosmetikk",
					"COSTUMES_AND_PARTY_SUPPLIES": "Fritid, sport og hobby: kostymer og festartikler",
					"DATING_SERVICES": "Immaterielle produkter: datingtjenester",
					"DECORATION_AND_ART": "Hjem og hage: dekorasjon og kunst",
					"DIETARY_SUPPLEMENTS": "Helse og skjønnhet: kosttilskudd",
					"DIGITAL_SERVICES": "Immaterielle produkter: digitale tjenester",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Barneprodukter: diverse barneprodukter",
					"DIVERSIFIED_ELECTRONICS": "Elektronikk: diverse",
					"DIVERSIFIED_ENTERTAINMENT": "Underholdning: diverse underholdning",
					"DIVERSIFIED_EROTIC_MATERIAL": "Erotiske materialer: diverse erotiske materialer",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Helse og skjønnhet: Diverse helse- og skjønnhetsprodukter",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Hjem og hage: diverse produkter til hjem og hage",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Smykker og tilbehør: diverse smykker og tilbehør",
					"EDUCATION": "Immaterielle produkter: utdanning",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronikk: elektronisk utstyr og tilbehør",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotiske materialer: erotiske klær og tilbehør",
					"EVENT_TICKETS": "Immaterielle produkter: billetter til arrangementer",
					"FOOD_AND_BEVERAGE": "Mat og drikke: mat og drikke",
					"FRAGRANCES": "Helse og skjønnhet: dufter",
					"FURNITURE": "Hjem og hage: møbler",
					"GENERAL_SHOES_AND_CLOTHING": "Klær og sko: generelle sko og klær",
					"HOBBY_ARTICLES": "Fritid, sport og hobby: hobbyartikler",
					"HOUSEHOLD_ELECTRONICS": "Elektronikk: husholdningselektronikk",
					"JEWELRY_AND_WATCHES": "Smykker og tilbehør: smykker og klokker",
					"KITCHENWARE": "Hjem og hage: kjøkkenutstyr",
					"MARKETPLACES": "Immaterielle produkter: markedsplasser",
					"MUSIC_AND_MOVIES": "Underholdning: musikk og film",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Fritid, sport og hobby: musikkinstrumenter og utstyr",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Smykker og tilbehør: solbriller og linser uten resept",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronikk: kontormaskiner og tilbehør",
					"OTHER_SERVICES": "Immaterielle produkter: andre tjenester",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Helse og skjønnhet: personlig pleie og forbedring av kropp",
					"PET_SUPPLIES": "Hjem og hage: kjæledyrutstyr",
					"PHARMACEUTICAL_PRODUCTS": "Helse og skjønnhet: farmasøytiske produkter",
					"PLANTS_AND_FLOWERS": "Hjem og hage: planter og blomster",
					"PRESCRIPTION_OPTICS": "Helse og skjønnhet: reseptbelagte optikk",
					"PRINTS_AND_PHOTOS": "Fritid, sport og hobby: utskrifter og bilder",
					"SAFETY_PRODUCTS": "Hjem og hage: sikkerhetsprodukter",
					"SEX_TOYS": "Erotiske materialer: sexleketøy",
					"SPORTS_GEAR_AND_OUTDOOR": "Fritid, sport og hobby: sportsutstyr og utendørs",
					"TOBACCO": "Mat og drikke: tobakk",
					"TOOLS_AND_HOME_IMPROVEMENT": "Hjem og hage: verktøy og oppussing",
					"TRAVEL_SERVICES": "Immaterielle produkter: reisetjenester",
					"UNDERWEAR": "Klær og sko: undertøy",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Underholdning: dataspill og tilbehør",
					"WHEELS_AND_TIRES": "Bilprodukter: dekk og felg",
					"WINE_BEER_AND_LIQUOR": "Mat og drikke: vin, øl og sprit",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Klær og sko: sko og klær til ungdom",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Aldersbegrenset - gambling, tipping, kasinoer og lotteri",
					"CHARITIES_AND_NGO": "Immaterielle produkter - Veldedige organisasjoner og ikke-statlige organisasjoner",
					"EROTIC_SERVICES": "Erotiske materialer - Erotiske tjenester",
					"FINANCIAL_SERVICES_CRYPTO": "Finansielle tjenester - Kryptorelaterte aktiviteter",
					"FINANCIAL_SERVICES_MSB": "Finansielle tjenester - Pengetjenestevirksomhet",
					"FINANCIAL_SERVICES_E_WALLETS": "Finansielle tjenester - E-lommebøker",
					"FINANCIAL_SERVICES_TRADING": "Finansielle tjenester - Handel",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Immaterielle produkter - Sosiale plattformfellesskap",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Reise - Flyreiser og cruiseoperatører",
					"TRAVEL_BROKER_AND_AGENCIES": "Reise - Agenter og byråer",
					"TRAVEL_GROUND_TRANSPORTATION": "Reise - Bakketransport",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Reise - Overnatting og resorter",
					"EVENT_ORGANIZER": "Event – Arrangør",
					"EVENT_BROKER_AND_AGENCIES": "Event - Agenter og byråer"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "California",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Hawaii",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "North Carolina",
					"ND": "North Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "South Carolina",
					"SD": "South Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "West Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Person",
						"COMPANY": "Selskap"
					},
					"roles": {
						"OWNER": "Eier",
						"ULTIMATE_BENEFICIAL_OWNER": "Endelig rettighetsinnehaver",
						"CONTROL_OVER_MANAGEMENT": "Styringskontroll",
						"APPLICANT": "Signaturberettigede",
						"SOLE_TRADER": "Eneforhandler",
						"PARTNER": "Partner"
					}
				},
				"payment_intervals": {
					"DAILY": "Daglig",
					"WEEKLY": "Ukentlig"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Vanlig varesalg",
						"description": "Forhandler selger produkter eller tjenester på en tradisjonell måte: Varene anses som brukt når de er levert, og det er vanligvis ingen utvidet periode mellom bestilling og levering"
					},
					"VOUCHER": {
						"label": "Kupong",
						"description": "Mer enn 10 % av salget består av kuponger og / eller gavekort"
					},
					"MEMBERSHIP": {
						"label": "Medlemskap",
						"description": "Mer enn 10 % av salget består av medlemskap"
					},
					"SUBSCRIPTION": {
						"label": "Abonnement",
						"description": "Mer enn 10 % av salget består av abonnementer"
					},
					"PHARMACIES": {
						"label": "Apotek",
						"description": "Forhandler selger reseptbelagte eller reseptfrie legemidler"
					},
					"US_PHARMACIES": {
						"label": "Amerikanske apotek",
						"description": "Forhandler selger reseptbelagte eller reseptfrie medisiner i USA"
					},
					"MEDICAL_SERVICES": {
						"label": "Medisinske tjenester",
						"description": "Forhandler selger medisinske tjenester som testing, undersøkelser, sykepleie"
					},
					"MARKETPLACES": {
						"label": "Markedsplasser",
						"description": "Forhandler har en underleverandør"
					},
					"FIREARM_DEALERS": {
						"label": "Skytevåpenforhandlere",
						"description": "Forhandler selger våpen, ammunisjon som krever lisens"
					},
					"AUCTIONS": {
						"label": "Auksjoner",
						"description": "Forhandler er et auksjonshus"
					},
					"ALCOHOL": {
						"label": "Alkohol",
						"description": "Forhandler selger alkohol"
					},
					"TOBACCO": {
						"label": "Tobakk",
						"description": "Forhandler selger tobakk inkludert eller ekskludert nikotin eller forhandler selger e-sigaretter"
					},
					"HEMP_CBD_THC": {
						"label": "Hamp, CBD, eller THC",
						"description": "Forhandler selger produkter som inneholder hamp, CBD eller THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Donasjoner og veldedighet",
						"description": "Forhandler er en donasjons- eller veldedighetsorganisasjon som går i gang med «utbetaling etter forlik»"
					},
					"TRAVEL": {
						"label": "Reise",
						"description": "Mer enn 10 % av salget består av reiser"
					},
					"EVENTS": {
						"label": "Arrangementer",
						"description": "Mer enn 10 % av salget består av arrangementer"
					},
					"COURSES": {
						"label": "Kurs",
						"description": "Mer enn 10 % av salget består av kurs"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Utdanningskurs",
						"description": "Forhandleren selger utdanningskurs som varer i en bestemt tidsperiode."
					},
					"FOOD_DELIVERY": {
						"label": "Matlevering",
						"description": "Forhandleren tilbyr en matleveringstjeneste."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Tilpasset forhåndsbestilling/møbler",
						"description": "Forhandleren selger forhåndsbestilte produkter, for eksempel møbler."
					},
					"DIGITAL_CONTENT": {
						"label": "Digitalt innhold",
						"description": "Forhandleren selger digitalt innhold, som e-bøker og nettspill."
					},
					"GAMING_INDUSTRY": {
						"label": "Spillindustri (gambling, tipping, kasinoer, lotteri)",
						"description": "Forhandleren leverer tjenester relatert til spillindustrien, som gambling, tipping, kasinoer og lotterier."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hei, {fornavn}",
						"primary_title_without_name": "Hei,",
						"sub_title": "Mer Klarna er mer Klarna, som Shakespeare sa.",
						"sub_title_no_products": "Begynn Klarna-opplevelsen ved å velge et produkt under",
						"sub_title_kp_products": "Velg et annet Klarna-produkt",
						"sub_title_ongoing_product": "Fortsett oppsettet av {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Produktbetaling",
							"text_blocks": [
								{
									"text": "LEgg til en løsning på oppsettet"
								}
							]
						}
					},
					"buttons": {
						"start": "Begynn",
						"continue": "Fortsett",
						"view_summary": "Se oppsummering",
						"add_another_product": "Legg til et prokt"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground-miljø",
							"text": "Bytt til Playground Environment for å utforske og generere Test API-legitimasjon, slik at du kan teste plattformen.",
							"link": "Playground-miljø"
						},
						"marketing_assets": {
							"title": "Markedsføringsressurser",
							"text": "Bruke Klarna betyr smoooth tilgang for kundene dine. Bruk våre markedsressurser for å få dem på gli.",
							"link": "Få ressurser"
						},
						"your_application": {
							"title": "Din søknad",
							"text": "Klikk her for å fullføre oppsettet ditt eller se programinformasjonen din, inkludert Vilkår og Betingelser.",
							"link": "Åpen"
						},
						"invite_more_users": {
							"title": "Inviter flere brukere",
							"text": "Inviter dine medarbeidere til selgerportalen, du vil kunne sette tilpassede tillatelser for hver av dem!",
							"link": "Inviter brukere"
						}
					},
					"footer": {
						"title": "Alltid inkludert i Klarna",
						"list": {
							"merchant_portal": {
								"title": "Merchant Portal",
								"text_blocks": [
									{
										"text": "Styr alt gjennom Klarna, med full tilgang til backend-prosedyrer"
									}
								]
							},
							"global_products": {
								"title": "Globale produkter, lokale gjes",
								"text_blocks": [
									{
										"text": "Alle våre produkter er ment å skulle møte lokale preferanser og lovgiving."
									}
								]
							},
							"local_support": {
								"title": "Lokal support for deg og dine kunder",
								"text_blocks": [
									{
										"text": "Vi har tusenvis av folk som er klar til å hjelpe dine kunder når de trenger den menneskelige faktoren."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna som markedsføringsredskap",
								"text_blocks": [
									{
										"text": "Vi gir deg tilgang til Klarna-materialer du kan bruke i markedsføringen."
									}
								]
							},
							"single_integration": {
								"title": "Enkel integrasjon, automatiske oppdateringer",
								"text_blocks": [
									{
										"text": "Én integrasjon, ingen oppdateringer. Noensinne."
									},
									{
										"text": "Når du har integrert Klarna, er det det. Det oppdateres kontinuerlig – og du trenger ikke løfte en finger."
									}
								]
							},
							"no_risk": {
								"title": "Ingen risiko for deg eller kundene",
								"text_blocks": [
									{
										"text": "Utbetalingene er alltid garantert, og kundene dekkes av Klarna Buyer Protection."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Klarna API-legitimasjon",
							"text_blocks": [
								{
									"text": "Brukernavn og passord for programmeringsgrensesnitt (API) i Klarna kobler produktet til butikken slik at du kan begynne å selge."
								}
							]
						},
						"toc_key": {
							"title": "Betingelser og vilkår",
							"text_blocks": [
								{
									"text": "Du må oppdatere vilkår og betingelser for netthandel"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Instruksjoner for integrering",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Hvordan bruke brukernavn og passord for programmeringsgrensesnitt (API) i Klarna",
							"ordered_list": {
								"one": "Generer og last ned brukernavn og passord",
								"two": "Lim inn legitimasjonen (brukernavn og passord til programmeringsgrensesnitt i Klarna (API)) i plattformen din som forklart i integrasjonsinstruksjonene nedenfor"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "Totalt 5 brukernavn og passord til programmeringsgrensesnitt i Klarna (API)",
							"text": "Du kan generere opptil fem brukernavn og passord til programmeringsgrensesnitt i Klarna (API). Få den første her, og opprett deretter resten i innstillinger.",
							"button": "Få brukernavn og passord for programmeringsgrensesnitt (API) i Klarna"
						},
						"how_to_update_toc": {
							"title": "Hvordan oppdatere vilkår og betingelser",
							"ordered_list": {
								"one": "Gå til koblingen",
								"two": "Les instruksjonene og kopier teksten",
								"three": "Inkluder det i vilkår og betingelser for nettbutikken"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Husk å oppdatere teksten med produktene du registrerte deg for.",
							"linkText": "Gå til oppdatering av vilkår og betingelser >"
						},
						"buttons": {
							"back": "Tilbake"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Søknaden blir vurdert…",
						"TRANSACTION_DETAILS_STARTED": "Søknaden blir vurdert av teamet vårt. Vi kommer tilbake til deg så snart som mulig.",
						"TRANSACTIONS_REVIEW_MANUAL": "Søknaden blir vurdert av teamet vårt. Vi kommer tilbake til deg så snart som mulig.",
						"TRANSACTIONS_ENABLED": "Gratulerer. Du er klar til å selge med Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Forespørselen om utbetalinger blir vurdert …",
						"PAYOUTS_REVIEW_MANUAL": "Forespørselen om utbetalinger vurderes av teamet vårt. Vi kommer tilbake til deg så snart som mulig.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Venter på ditt første salg med Klarna ...",
						"TRANSACTIONS_DISABLED": "Kontoen er deaktivert til du har fullført trinnet for aktivering av utbetalinger.",
						"SUSPENDED": "Kontoen er suspendert.",
						"notice": "Vi har for øyeblikket lengre ventetider enn vanlig for å gjennomgå søknaden. Det er ingen grunn til bekymring, søknaden behandles i øyeblikket, og vi tar kontakt med mer informasjon om veien videre. Takk for tålmodigheten."
					},
					"statuses": {
						"pending": "Venter",
						"done": "Ferdig"
					},
					"in_review": {
						"title": "Vi går gjennom søknaden din.",
						"subtitle": "Vi gjennomfører for øyeblikket en endelig gjennomgang av søknaden din med Klarna for å sikre at alt i kontrakten ser riktig ut. Dette er en manuell prosess, så behandlingstidene kan variere, men vi får det gjort så raskt som mulig.",
						"content": {
							"title": "For å sikre at gjennomgangen gjøres så raskt som mulig, må du sørge for at følgende er synlig på nettstedet ditt:",
							"list": {
								"default": {
									"item_1": "Ditt registrerte firmanavn",
									"item_2": "Ditt registrerte firmanummer",
									"item_3": "Din registrerte firmaadresse",
									"item_4": "Returpolicy på minst 14 dager",
									"item_5": "E-post eller telefonnummer til kundeservice"
								},
								"US": {
									"item_1": "Registrert firmanavn",
									"item_2": "Returpolicy",
									"irem_3": "E-post eller telefonnummer til kundeservice"
								},
								"AU": {
									"item_1": "ABN (firmanummer) eller registrert firmanavn.",
									"item_3": "Din registrerte firmaadresse",
									"item_4": "Returpolicy på minst 14 dager",
									"item_5": "E-post eller telefonnummer til kundeservice"
								}
							}
						},
						"footer": "Vi sender deg en e-post når gjennomgangen er fullført, eller hvis vi trenger ytterligere informasjon fra deg."
					},
					"suspended": {
						"title": "Beklager...",
						"subtitle": "Etter å ha gjennomgått kontraktsopplysningene dine, måtte vi avslå søknaden din. Det kan være flere årsaker til at søknaden din ikke ble godkjent. Nedenfor er noen av de vanligste generelle faktorene:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Butikken din overholder ikke de etiske retningslinjene til Klarna.",
								"item_2": "Kontaktpersonen som er oppgitt er ikke tilgjengelig.",
								"item_3": "Andre tekniske eller administrative faktorer."
							}
						},
						"footer": "Takk for din interesse for Klarna. Kontakt oss hvis du har spørsmål, eller hvis du vil registrere deg med en annen butikk i fremtiden."
					},
					"disabled": {
						"title": "Søknaden din er deaktivert.",
						"subtitle": "Kontoen din ble automatisk deaktivert fordi den mangler lovpålagt informasjon.",
						"content": {
							"title": "Dette skjer vanligvis når Klarna har bedt deg om å oppgi informasjon og du ikke har svart før den angitte forfallsdatoen."
						},
						"footer": "Hvis du mener dette er en feil eller ønsker å sende inn informasjonen på nytt, kan du kontakte forhandlersupport ved hjelp av kontaktinformasjonen i bunnteksten på denne siden."
					},
					"ready_to_connect": {
						"title": "Koble til butikken din",
						"subtitle": "Kontrakten din er fullført, og du kan nå integrere Klarna i butikken din. Følg trinnene nedenfor for å fullføre integrasjonen.",
						"status_messsage": {
							"title": "Integrasjonen er ennå ikke fullført",
							"subtitle": "Følg integrasjonsinstruksjonene for å koble til butikken din. Denne statusen blir grønn når en transaksjon er gjort med Klarna."
						},
						"content": {
							"title": "Instruksjoner",
							"options": {
								"label_1": "Generer og lagre Klarna API-legitimasjonen",
								"description_1": "Generer nye API-legitimasjoner og last dem ned til datamaskinen din. Du trenger disse API-legitimasjonene i neste avsnitt.",
								"label_2": "Installer Klarna i Shopify-butikken din"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Snart ferdig",
						"subtitle": "Du er ett skritt nærmere å tilby en smoooth shoppingopplevelse for kundene dine! Kontrakten din er fullført og butikken din er klar for integrering.",
						"buttons": {
							"connect": "Koble til butikken din"
						},
						"additional_info": "Vær oppmerksom på at integrasjonen først vil bli merket som fullført når vi mottar det første kjøpet, noe som kan ta en stund avhengig av plattformen din."
					},
					"store_connected": {
						"title": "Butikken din er tilkoblet",
						"subtitle": "Butikkintegrasjonen din til Klarna er fullført, og kundene dine kan betale med Klarna.",
						"status_messsage": {
							"title": "Integrasjon vellykket",
							"subtitle": "En Klarna-transaksjon er behandlet gjennom butikken din.",
							"button_text": {
								"shown": "Vis instruksjoner for integrering",
								"hidden": "Skjul instruksjoner for integrering"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Din søknad",
							"subtitle": "Gå gjennom applikasjonsinformasjonen din.",
							"button_text": "Vis sammendrag"
						},
						"connect_store": {
							"title": "Brukernavn og passord for programmeringsgrensesnitt (API) i Klarna",
							"subtitle": "Generer Klarna API-legitimasjon for å integrere butikken din.",
							"button_text": "Generer Klarna API-legitimasjon"
						},
						"add_product": {
							"title": "Produkter",
							"subtitle": "Klikk her hvis du vil legge til et produkt for dette oppsettet.",
							"button_text": "Legg til produkter"
						}
					},
					"timeline": {
						"application": {
							"title": "Din søknad",
							"alert": {
								"view_summary": "Vis sammendrag",
								"rejected": "Vi måtte avslå søknaden din.",
								"review": "Se gjennom søknadsinformasjonen din ved å klikke på lenken nedenfor."
							}
						},
						"payouts": {
							"title": "Utbetalinger aktivert"
						},
						"integration": {
							"title": "Integrasjonen er ennå ikke fullført",
							"alert": "Følg integreringsinstruksjonene for å koble til butikken din."
						},
						"integration_complete": {
							"title": "Integrasjon fullført!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Gratulerer, oppsettet er fullført!",
						"rejection": "Vi kunne ikke fullføre oppsettet."
					},
					"header_new": {
						"title": "Velkommen, Klarna-forhandler",
						"subtitle": "Oppsummering",
						"rejection": "Søknad avslått"
					},
					"joy_section": {
						"approved": {
							"title": "Godkjent!",
							"content": "Søknaden er vurdert og godkjent. Full tilgang til Klarnas tjenester er nå innen rekkevidde. Vi gleder oss til å samarbeide med deg!",
							"button_title": "Sjekk ordrene",
							"link": "eller markedsføringsmidlene våre"
						},
						"rejected": {
							"title": "Dessverre ...",
							"content_1": "Etter å ha vurdert søknaden, kan vi ikke godkjenne forhandlerkontrakten.",
							"content_2": "Ta gjerne kontakt med kundestøtte hvis du har spørsmål."
						}
					},
					"sidebar_left": {
						"application_details": "Søknadsopplysningene",
						"store_details": {
							"title": "Butikkdetaljer",
							"text_blocks": [
								{
									"text": "Sammendrag av personopplysninger"
								}
							]
						},
						"credentials": {
							"title": "Brukernavn og passord for programmeringsgrensesnitt (API) i Klarna",
							"text_blocks": [
								{
									"text": "Brukernavn og passord til programmeringsgrensesnitt i Klarna (API)"
								}
							]
						},
						"payouts": {
							"title": "Utbetalinger",
							"text_blocks": [
								{
									"text": "De innsendte bankopplysningene"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Ytterligere bankkontoer",
							"text_block": null
						},
						"business_owners": {
							"title": "Bedriftseiere",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Materielle påvirkere",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Interessenter",
							"text_blocks": [
								{
									"text": "Den innsendte informasjonen"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Bedriftseiere",
								"no_elements": "Du sendte ikke inn noen forretningseiere"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Standard bankkonto",
								"no_elements": "Ingen standard bankkonto tilgjengelig"
							},
							"additional_bank_accounts": {
								"title": "Ytterligere bankkontoer",
								"no_elements": "Du sendte ikke inn noen ekstra bankkontoer"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Eiere",
								"no_elements": "Du sendte ikke inn noen eiere"
							},
							"ultimate_beneficial_owner": {
								"title": "Gunstige eiere",
								"no_elements": "Du sendte ikke inn noen gunstige eiere"
							},
							"applicant": {
								"title": "Søkere",
								"no_elements": "Du sendte ikke inn noen søkere"
							},
							"control_over_management": {
								"title": "Personer med kontroll over ledelsen",
								"no_elements": "Du har ikke sendt inn noen interessenter med kontroll over ledelsen"
							}
						},
						"buttons": {
							"back": "Tilbake",
							"next_step": "Neste"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Vi har allerede dataene dine",
							"text_blocks": [
								{
									"text": "Dette er informasjonen du tidligere har gitt oss."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Du sendte ikke inn noen forretningseiere"
						},
						"buttons": {
							"submit": "Send inn",
							"back": "Tilbake"
						}
					}
				},
				"checking_page": {
					"title": "Kontrollerer ...",
					"subtitle": "Takk for at du sendte inn søknaden. Vent mens vi sjekker den ..."
				},
				"success_page": {
					"title": "Du kan nå koble til butikken",
					"subtitle": "Takk for at du sendte inn søknaden.",
					"buttons": {
						"next": "Neste"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Grunnleggende",
						"business": "Virksomhet",
						"stakeholders": "Interessenter",
						"bank_accounts": "Bankkontoer"
					}
				},
				"app_error": {
					"title": "Produkt-appen er ikke tilgjengelig for øyeblikket",
					"message": "Vi har problemer med søknaden og er allerede på saken. Vi prøver å løse problemene så snart som mulig. Prøv igjen senere."
				},
				"temporarily_down": {
					"title": "Vi har tekniske problemer",
					"message": "Vi beklager bryet og forsikrer deg om at vi gjør vårt beste for å løse problemet. Kom tilbake senere."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Produkt-appen er for tiden nede på grunn av vedlikehold",
						"signup_app": "Registreringsappen er for øyeblikket nede på grunn av vedlikehold"
					},
					"message": "Vi jobber for å gjøre opplevelsen bedre og håper å være ferdig så snart som mulig. Kom tilbake senere."
				},
				"unknown_merchant": {
					"before_link": "Hvis du allerede har en avtale med oss kan du gå til",
					"link_text": "denne siden",
					"after_link": "for å finne ut mer om produktene våre!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Det har oppstått en feil.",
						"invalid_token": "Denne lenken har utløpt"
					},
					"message": {
						"invalid_token_risk": "Ta kontakt med #smooothforce-support-kanalen, så hjelper vi deg.",
						"invalid_token": "Ta kontakt med salgskontakten.",
						"invalid_flow_type": "Denne forhandlerens type igangkjøring og status stemmer ikke overens. Hvis du mener det er en feil, kan du kontakte forhandlersupport."
					}
				},
				"topbar": {
					"title": "Oppsett",
					"widget_type": {
						"MANAGED_KYC": "KYC kolleksjon",
						"MANAGED_RISK": "Samling av forhåndsvurderinger",
						"MANAGED_SME_RISK": "SME-samling av forhåndsvurderinger"
					}
				},
				"product_card": {
					"incompatible_description": "Ikke tilgjengelig for ditt land/plattform",
					"kco_footer_text": "Hvilke betalingsmetoder som er tilgjengelige i Klarna Checkout avhenger av landet du er registrert i og landet du selger til.",
					"products_link_text": "Mer"
				},
				"product_prices_card": {
					"title": "Produkter",
					"subtitle": "{country}",
					"pricing": "Priser for {country}",
					"monthly_fee": "månedlig avgift",
					"transaction_fee": "transaksjonsgebyr",
					"before_link": "Jeg er enig i Klarnas",
					"link_text": "Vilkår og betingelser",
					"after_link_one_product": "for dette produktet",
					"after_link_more_than_one_product": "for disse produktene",
					"product_not_available_in_your_country": "* Dette produktet finnes ikke i dette markedet, men det vil fungere i andre land.",
					"edit_link": "Endre",
					"merchant_agreement": {
						"before_link": "Jeg godtar",
						"link_text": "Forhandleravtalen",
						"after_link_one_product": "for dette produktet",
						"after_link_more_than_one_product": "for disse produktene"
					},
					"pricing_annex": {
						"before_link": "Jeg godtar",
						"link_text": "prisbetingelsene",
						"after_link_one_product": "for dette produktet"
					}
				},
				"support_footer": {
					"text": "Support på engelsk",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle rettigheter reservert.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Vilkår og betingelser.",
					"privacy_policy": "Personvernerklæring",
					"merchant_id": "Forhandler-ID {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Forhandlersupport",
					"recaptcha": {
						"1_main_text": "Dette nettstedet er beskyttet av reCAPTCHA og Google",
						"2_privacy_policy": "Personvern",
						"3_and": "og",
						"4_terms_of_service": "Vilkår for bruk",
						"5_apply": "søk."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Priser for alle våre markeder",
					"title_us": "Priser",
					"subtitle": "Du blir kun belastet et gebyr per transaksjon, og det er smoooth!",
					"table": {
						"country": "Land",
						"price_column_heading": "Gebyr per transaksjon",
						"global": "Global",
						"title": {
							"kp": "Betalingsmetoder",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarnas betalingsmetode"
						},
						"headers": {
							"kp_one": "Serviceavgift"
						}
					},
					"buttons": {
						"back": "Tilbake"
					},
					"foot_notes": {
						"global_price": "* Lokal valuta for forhandler, ellers "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Første transaksjon",
						"content": "Før vi kan se gjennom utbetalingsinformasjonen, trenger vi den første ordren. Vil du ikke kaste bort dine egne penger? Ikke noe problem!",
						"button": "Du kan fake!"
					},
					"transactions": {
						"title": "Godkjenn transaksjoner",
						"content": "Du kan godt fake godkjenningen for godkjent salgstransaksjon",
						"button": "Godkjenn"
					},
					"payouts": {
						"title": "Godkjenn utbetalinger",
						"content": "Du kan godt fake godkjenningen for salgsutbetaling",
						"button": "Godkjenn"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Standard bankkonto",
						"additional": "Ytterligere bankkonto {index}",
						"normal": "Bankkonto {index}"
					},
					"currency_code": {
						"label": "Valuta"
					},
					"country_of_bank_account": {
						"label": "Land"
					},
					"account_number": {
						"label": {
							"default": "Kontonummer",
							"MX_LOCAL": "CLABE-nummer"
						}
					},
					"account_holder": {
						"label": "Navn på kontoinnehaver"
					},
					"routing_number": {
						"label": "Rutingnummer"
					},
					"transit_number": {
						"label": "Transittnummer"
					},
					"institution_number": {
						"label": "Institusjonsnummer"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Du kan endre kontoinformasjon etter at du har fullført onboardingen"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Selskapets juridiske navn"
					},
					"country": {
						"label": "Land"
					},
					"registrationId": {
						"label": {
							"default": "Registreringsnummer",
							"AT": "Registreringsnummer",
							"AU": "ACN",
							"CA": "Forretningsnummer",
							"ES": "Firma-NIF/NIE/DNI",
							"GB": "Organisasjonsnummer",
							"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"US": "Arbeidsgivers identifikasjonsnummer"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Tinglysingsdomstol"
					},
					"goodsCategory": {
						"label": "Varekategori"
					},
					"registered": {
						"label": {
							"default": "Registrert virksomhet",
							"AU": "Virksomheten har et ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Momspliktig virksomhet",
							"AU": "Virksomhet underlagt ABN",
							"ES": "Bedriften har en NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "MVA-nummer",
							"AU": "ABN",
							"ES": "Firma-NIF/NIE/DNI"
						}
					},
					"storeName": {
						"label": "Butikknavn"
					},
					"website": {
						"label": "Nettsted"
					},
					"email": {
						"label": "E-post til kundestøtte"
					},
					"entityType": {
						"label": "Enhetstype"
					},
					"toc_data": {
						"label": "Vilkår",
						"toc_approval_text": {
							"before_link": "Din",
							"link_text": "Vilkår og betingelser",
							"after_link": "akseptert den {date}",
							"merchant_agreement": {
								"before_link": "Ditt",
								"link_text": "Forhandleravtale",
								"after_link": "godkjent {date}"
							},
							"pricing_annex": {
								"before_link": "Ditt",
								"link_text": "prisvedlegg",
								"after_link": "godkjent {date}"
							}
						}
					},
					"companyName": {
						"label": "Partnerskapets navn"
					},
					"registeredCompanyName": {
						"label": "Virksomhetens navn"
					},
					"address": {
						"label": "Adresse"
					},
					"operatingAddress": {
						"label": "Driftsadresse"
					},
					"organizationEntityType": {
						"label": "Skatteklassifisering"
					}
				},
				"api_key_dialog": {
					"title": "Klarna API-legitimasjon generert",
					"subtitle": "Påloggingsinformasjonen vises bare én gang. Klikk på knappen nedenfor for å laste ned legitimasjonen din før du lukker dette vinduet.",
					"key_box": {
						"username": {
							"label": "Brukernavn for programmeringsgrensesnitt (API) i Klarna"
						},
						"password": {
							"label": "Passord for programmeringsgrensesnitt (API) i Klarna"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Last ned som .txt"
					}
				},
				"platform_instructions": {
					"step": "Trinn {current} / {max}",
					"next": "Neste",
					"back": "Tilbake",
					"shopify": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste del."
									}
								]
							],
							"alternate": [
								{
									"text": "For å få mer detaljert informasjon om Shopify-integrasjonen, følg den"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "utvidede integrasjonsveiledningen."
								}
							]
						},
						{
							"title": "Installer Klarna i Shopify-butikken din",
							"step_instructions": [
								[
									{
										"text": "Gå til"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Oppsett av kontrollprogram for Klarnas betalingsmetode på Shopify."
									}
								],
								[
									{
										"text": "Følg instruksjonen der for å fullføre integrasjonen."
									}
								]
							],
							"alternate": [
								{
									"text": "For å få mer detaljert informasjon om Shopify-integrasjonen, følg"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "utvidede integrasjonsveiledningen."
								}
							]
						},
						{
							"title": "Legg inn et prøvekjøp",
							"step_instructions": [
								[
									{
										"text": "For å bekrefte at integrasjonen er riktig konfigurert, legg inn prøvekjøp i butikken din."
									}
								],
								[
									{
										"text": "Etter å ha lagt inn bestillingen, gå til"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordre i Merchant Portal,"
									},
									{
										"text": "finn bestillingen din og kanseller den for å unngå å betale for den selv."
									}
								],
								[
									{
										"text": "Når integreringen er vellykket, blir banneret øverst på denne siden grønt og viser ordene \"Integrasjon fullført\"."
									}
								]
							],
							"alternate": [
								{
									"text": "For å få mer detaljert informasjon om Shopify-integrasjonen, følg"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "utvidede integrasjonsveiledningen."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Aktiver programtillegg for Klarnas betalingsmetode på Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "For å kunne installere Klarna programtillegg trenger du et system som kjører med Plentymarkets CERES. En"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres-plugin"
									},
									{
										"text": "er tilgjengelig for nedlasting på plentyMarketplace. Derfra blir du også omdirigert til"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "installeringsinstruksjoner."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detaljert informasjon om Klarna-integrasjon med Plentymarkets Ceres vennligst følg"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "denne linken."
									}
								]
							]
						},
						{
							"title": "Installering og oppsett",
							"step_instructions": [
								[
									{
										"text": "Installering av Klarna-plugin gjøres via"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Du blir også omdirigert til plentyMarketplace fra plentymarkets-systemets serverdel. En"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instruksjon hvordan installere plugins i plentymarkets"
									},
									{
										"text": "finner du på plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detaljert informasjon om Klarna-integrasjon med Plentymarkets Ceres vennligst følg"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "denne linken."
									}
								]
							]
						},
						{
							"title": "Konfigurasjon av programtillegg",
							"step_instructions": [
								[
									{
										"text": "Programtillegg er konfigurert direkte i det respektive settet. Ved å klikke på linjen i"
									},
									{
										"bold": "Klarna programtillegg"
									},
									{
										"text": "vil konfigurasjonssiden åpnes."
									}
								],
								[
									{
										"text": "Konfigurasjonen er delt inn i to områder:"
									},
									{
										"list": [
											[
												{
													"bold": "Godkjenning:"
												},
												{
													"text": "Modusen brukes til å bestemme om den er testende eller produktiv. Avhengig av modus må brukernavnet og passordet lagres."
												}
											],
											[
												{
													"bold": "Generelle innstillinger:"
												},
												{
													"text": "Her velger du produktet du vil bruke. En disse betalingsmetodene fra Klarna; (Klarna Payment) eller Klarnas fullstendige utsjekking (Klarna Checkout). Når du velger checkout, blir betalingen i butikken automatisk overskrevet av Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "Ingen ytterligere innstillinger er nødvendig, og hvis du deaktiverer pluginen, vil dette angres."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detaljert informasjon om Klarna-integrasjon med Plentymarkets Ceres vennligst følg"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "denne linken."
									}
								]
							]
						},
						{
							"title": "Endelig informasjon",
							"step_instructions": [
								[
									{
										"text": "Følgende systemkrav gjelder:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets versjon 7"
											},
											{
												"text": "Ceres og IO programtillegg er installert"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For detaljert informasjon om Klarna-integrasjon med Plentymarkets Ceres vennligst følg"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "denne linken."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Aktiver Klarna Checkout programtillegg for WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Først, sørg for at du har installert Klarna Checkout-plugin for WooCommerce. Hvis du ikke har pluginen ennå, gå til"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								],
								[
									{
										"text": "Når du har brukernavn og passord til programmeringsgrensesnitt i Klarna (API), gå til innstillinger og deretter Checkout i WooCommerce-panelet. Velg Klarna Checkout."
									}
								],
								[
									{
										"text": "Aktiver Klarna Checkout ved å merke av i avkrysningsboksen Aktiver Klarna Checkout."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integreringen av WooCommerce , se den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utvidede guiden."
									}
								]
							]
						},
						{
							"title": "Konfigurer innstillingene",
							"step_instructions": [
								[
									{
										"text": "Konfigurer innstillingene for Klarna Checkout. Merk at feltet \"Tittel\" brukes til å angi tittelen for betalingsmetoden som vises i kassen og bestillingsbekreftelses-e-postadressene (dvs. Klarna Checkout)."
									}
								],
								[
									{
										"text": "Merk av i avkrysningsruten \"Testmodus\" hvis du vil opprette bestillinger med testopplysningene."
									}
								],
								[
									{
										"text": "Nå er det på tide å fylle ut landinnstillinger. Hvis du er basert i Europa, klikker du på \"utvide\" på Europa-delen. Hvis du er basert i USA, klikker du på \"utvide\" i USA-delen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integreringen av WooCommerce , se den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utvidede guiden."
									}
								]
							]
						},
						{
							"title": "Legg til egne brukernavn og passord for programmeringsgrensesnitt (API) i Klarna",
							"step_instructions": [
								[
									{
										"text": "Legg til egne brukernavn og passord for programmeringsgrensesnitt (API) i Klarna, i feltene for brukernavn og passord."
									}
								],
								[
									{
										"text": "Lagre dine innstillinger"
									}
								],
								[
									{
										"text": "Det siste en må gjøre er å sette Klarna Checkout som standard betalingsmetode. Gå til \"Innstillinger\" og deretter \"Betalinger\" i WooCommerce-panelet ditt. Finn delen \"Betalingsmåter\" og sett Klarna Checkout som standard betalingsmetode."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integreringen av WooCommerce , se den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utvidede guiden."
									}
								]
							]
						},
						{
							"title": "Siste trinn",
							"step_instructions": [
								[
									{
										"text": "Vær sikker på at du aktiverer"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "flotte permalenker"
									},
									{
										"text": "i WordPress-installasjonen din. Ellers vil tilbakemeldnger fra Klarna til butikken din ikke virke, og bestillinger vil ikke bli oppdatert med riktig ordrestatus / informasjon."
									}
								],
								[
									{
										"text": "Hvis du vil håndtere Klarna-ordren direkte i WooCommerce, må du installere"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarna ordrebehandling-"
									},
									{
										"text": "plugin."
									}
								],
								[
									{
										"text": "Du må forsikre deg om at Klarna Checkout vises som forventet ved å legge et element i handlekurven din og fortsette til kassen (Ikke fullfør bestillingen)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integreringen av WooCommerce , se den"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "utvidede guiden."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer info om integrasjonen med WooCommerce, følger du"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "den store veiledningen til integrasjon."
									}
								]
							]
						},
						{
							"title": "Installer og aktiver programtillegg for Klarnas betalingsmetode",
							"step_instructions": [
								[
									{
										"text": "Installer"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Aktiver programtillegg for Klarnas betalingsmetode for WooCommerce."
									}
								],
								[
									{
										"text": "Inne på WooCommerce-kontoen din, gå til"
									},
									{
										"bold": "Innstillinger → Betalinger → Klarnas betalingsmetode."
									}
								],
								[
									{
										"text": "Aktiver Klarnas betalingsmetode når du krysser av i ruten for aktiver Klarnas betalingsmetode."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om WooCommerce-integreringen din, følg"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						},
						{
							"title": "Konfigurer innstillingene for land",
							"step_instructions": [
								[
									{
										"text": "Fyll ut land i innstillinger. Hvert Klarna-land har egne spesifikke innstillinger for det landet. Når du legger til forhandlers brukernavn og passord til et spesifikt land, må du aktivere Klarnas betalingsmetode som en tilgjengelig betalingsmetode for det landet."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om WooCommerce-integreringen din, følg"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						},
						{
							"title": "Oppgi brukernavn og passord for programmeringsgrensesnitt (API) i Klarna",
							"step_instructions": [
								[
									{
										"text": "Skriv inn Klarna API-legitimasjonen din i feltene for brukernavn og passord."
									}
								],
								[
									{
										"text": "Lagre dine innstillinger"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om WooCommerce-integreringen din, følg"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						},
						{
							"title": "Legg inn et prøvekjøp",
							"step_instructions": [
								[
									{
										"text": "For å bekrefte at integrasjonen er riktig konfigurert, legg inn prøvekjøp i butikken din."
									}
								],
								[
									{
										"text": "Etter å ha lagt inn bestillingen, gå til"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordre i Merchant Portal,"
									},
									{
										"text": "finn bestillingen din og kanseller den for å unngå å betale for den selv."
									}
								],
								[
									{
										"text": "Når integreringen er vellykket, blir banneret øverst på denne siden grønt og viser ordene \"Integrasjon fullført\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om WooCommerce-integreringen din, følg"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Konfigurer innstillingene dine for å aktivere Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Først, sørg for at du har installert Klarna Checkout-modulen for Magento. Hvis du ikke har modulen ennå, gå til"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								],
								[
									{
										"text": "Når du har brukernavn og passord til programmeringsgrensesnitt i Klarna (API), åpner du Magento-panelet. Gå til «Butikker» → «Konfigurasjon» → «Salg» → «Betalingsmetoder» → «Klarna» → «Programmeringsgrensesnitt (API) i Klarna»."
									}
								],
								[
									{
										"text": "Utvid delen for Klarnas programmeringsgrensesnitt (API) og oppgi API versjon og brukernavn og passord for Klarna. Sørg for å deaktivere testmodus hvis du er klar til å gå live på nettstedet."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om Magento-integrasjonen, sjekk ut deres"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "utvidede guiden."
									}
								]
							]
						},
						{
							"title": "Siste trinn",
							"step_instructions": [
								[
									{
										"text": "Når innstillingene dine er konfigurert, må du kontrollere at Klarna Checkout er satt som aktivert i dine betalingsalternativer."
									}
								],
								[
									{
										"text": "Gå til \"Butikker\" → \"Konfigurasjon\" → \"Salg\" → \"Checkout\" → \"Klarna Checkout-alternativer\", i Magento-panelet."
									}
								],
								[
									{
										"text": "Klarna Checkout skal være aktivert som standard. Hvis ikke, bytt til"
									},
									{
										"bold": "Aktivert"
									},
									{
										"text": "under “Enable Klarna Checkout”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							]
						},
						{
							"title": "Installer og aktiver modulen for Klarnas betalingsmetode",
							"step_instructions": [
								[
									{
										"text": "Besøk"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Brukerhåndbok for oppsett av Klarna i Magento"
									},
									{
										"text": "og følg instruksjonene der for å installere og konfigurere modulen på Magento-kontoen din."
									}
								]
							]
						},
						{
							"title": "Legg inn et prøvekjøp",
							"step_instructions": [
								[
									{
										"text": "For å bekrefte at integrasjonen er riktig konfigurert, legg inn prøvekjøp i butikken din."
									}
								],
								[
									{
										"text": "Etter å ha lagt inn bestillingen, gå til"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordre i Merchant Portal,"
									},
									{
										"text": "finn bestillingen din og kanseller den for å unngå å betale for den selv."
									}
								],
								[
									{
										"text": "Når integreringen er vellykket, blir banneret øverst på denne siden grønt og viser ordene \"Integrasjon fullført\"."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Aktiver programtillegget for Klarnas betalingsmetode på Shopware",
							"step_instructions": [
								[
									{
										"text": "Pass på at du først installerer programtillegget for Klarnas betalingsmetode på Shopware. Har du ikke programtillegget enda, går du til"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								],
								[
									{
										"text": "Videre må du importere programtillegg for Klarnas betalingsmetode til Shopware. Det gjør du når du klikker gjennom"
									},
									{
										"bold": "Konfigurasjon → Administrer programtillegg → Installert → Last opp programtillegg."
									},
									{
										"text": "Klikk"
									},
									{
										"bold": "Velg"
									},
									{
										"text": "og velger ZIP-filen som inneholder programtillegget for Klarnas betalingsmetode. Bekreft med et tastetrykk"
									},
									{
										"bold": "Upload Plugin"
									},
									{
										"text": "Pluginen kan nå bli funnet i plugin-manager."
									}
								],
								[
									{
										"text": "Installer pluginen ved å klikke på"
									},
									{
										"bold": "grønn “+”"
									},
									{
										"text": "-ikonet"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Konfigurer programtillegget for Klarnas betalingsmetode på Shopware",
							"step_instructions": [
								[
									{
										"text": "Naviger til plugininnstillingene ved å klikke"
									},
									{
										"bold": "Konfigurasjon → Grunnleggende innstillinger → Søk etter Klarnas betalingsmetode"
									}
								],
								[
									{
										"text": "Oppgi brukernavn og passord for programmeringsgrensesnitt (API) i Klarna i feltene"
									},
									{
										"bold": "Brukernavn for programmeringsgrensesnitt (API) i Klarna"
									},
									{
										"text": "og"
									},
									{
										"bold": "Passord for programmeringsgrensesnitt (API) i Klarna"
									},
									{
										"text": "og lagre endringer"
									}
								],
								[
									{
										"text": "Se til at du er i live modus og bruk brukernavn og passord til programmeringsgrensesnitt i Klarna (API)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Konfigurer porten(e) til Klarnas betalingsmetode",
							"step_instructions": [
								[
									{
										"text": "Før du bruker Klarna, må du aktivere porten(e) til Klarnas betalingsmetode. Du finner disse når du klikker på"
									},
									{
										"bold": "Konfigurasjon → Betalingsmetoder"
									}
								],
								[
									{
										"text": "Klarnas betalingsmetode. Du åpner portene til Klarnas betalingsmetode, som du registrerte deg for, og aktiverer disse ved å krysse av"
									},
									{
										"bold": "Aktivert"
									},
									{
										"text": "i avkryssingsboksen. Lagre endringene dine."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Konfigurer fraktkostnadene dine",
							"step_instructions": [
								[
									{
										"text": "Konfigurer fraktkostnader for porten(e) til Klarnas betalingsmetode når du klikker på"
									},
									{
										"bold": "Konfigurasjon → Fraktkostnad"
									}
								],
								[
									{
										"text": "Velg fraktmetoden som skal være tilgjengelig for Klarna ved å klikke på"
									},
									{
										"bold": "blyantikonet."
									}
								],
								[
									{
										"text": "Velg fanen for valg av betalingsmetode og flytt porten(e) for Klarnas betalingsmetode fra"
									},
									{
										"bold": "Tilgjengelig"
									},
									{
										"text": "til"
									},
									{
										"bold": "Valgt"
									},
									{
										"text": "Lagre dine innstillinger"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Klarnas betalingsmetode",
							"step_instructions": [
								[
									{
										"text": "Videre må du aktivere programtillegget for Klarnas betalingsmetode. Klikk gjennom"
									},
									{
										"bold": "Konfigurasjon → Administrer programtillegg → Installert"
									},
									{
										"text": "for å finne Plugin Manager."
									}
								],
								[
									{
										"text": "Aktiver plugin ved å klikke på"
									},
									{
										"bold": "rød \"X\""
									},
									{
										"text": "-ikonet"
									}
								],
								[
									{
										"text": "Du vil bli spurt om du vil tømme hurtigbufferen. Klikk på"
									},
									{
										"bold": "Ja."
									},
									{
										"text": "Vær oppmerksom på at du må tømme hurtigbufferen og kompilere temaer hver gang du endrer noe i modulinnstillingene eller betalingsmetodene fra Klarna."
									}
								],
								[
									{
										"text": "For å aktivere Klarnas betalingsmetode programtillegg fullt ut, må butikkens tema kompileres på nytt. Klikk på"
									},
									{
										"bold": "Kompilere temaer"
									},
									{
										"text": "når du blir spurt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Siste trinn",
							"step_instructions": [
								[
									{
										"text": "For å unngå avrundingsfeil, må du sørge for at PHP-utvidelsen bcmath er installert på serveren. Du finner veiledningen"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "her"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Start på nytt med en gang for å sikre at alle konfigurasjoner er tilgjengelige i butikken din."
									}
								],
								[
									{
										"text": "Du må forsikre deg om at Klarna Payment-produktene dine vises som forventet ved å legge til et element i handlekurven din, velge Klarna som betalingsmetode, og fortsett til kassen (Ikke fullfør bestillingen)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Aktiver Klarna Checkout-plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "Først av, sørg for at du har installert Klarna Checkout-plugin for Shopware (Versjon 5.2.17 og senere). Hvis du ikke har pluginen ennå, gå til"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								],
								[
									{
										"text": "I neste trinn må du importere Klarna Checkout programtillegg til Shopware ved å klikke gjennom"
									},
									{
										"bold": "Konfigurasjon → Administrer programtillegg → Installert → Last opp programtillegg."
									},
									{
										"text": "Klikk"
									},
									{
										"bold": "Velg"
									},
									{
										"text": "og velg ZIP-filen Klarna Checkout programtillegg. Bekreft med et tastetrykk"
									},
									{
										"bold": "Upload Plugin"
									},
									{
										"text": "Pluginen kan nå bli funnet i plugin-manager."
									}
								],
								[
									{
										"text": "Installer pluginen ved å klikke på"
									},
									{
										"bold": "grønn “+”"
									},
									{
										"text": "-ikonet"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Konfigurer Klarna Checkout-plugin for Shopware",
							"step_instructions": [
								[
									{
										"text": "Naviger til plugininnstillingene ved å klikke"
									},
									{
										"bold": "Konfigurasjon → Grunnleggende innstillinger → Søk etter Klarna Checkout"
									}
								],
								[
									{
										"text": "Oppgi brukernavn og passord for programmeringsgrensesnitt (API) i Klarna i feltene"
									},
									{
										"bold": "Brukernavn for programmeringsgrensesnitt (API) i Klarna"
									},
									{
										"text": "og"
									},
									{
										"bold": "Passord for programmeringsgrensesnitt (API) i Klarna"
									},
									{
										"text": "og lagre endringer"
									}
								],
								[
									{
										"text": "Se til at du er i live modus og bruk brukernavn og passord til programmeringsgrensesnitt i Klarna (API)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Aktiver Klarna Checkout betalingstilgang",
							"step_instructions": [
								[
									{
										"text": "Før du bruker Klarna, må du aktivere din Klarna Payment-tilgang(-er). Du kan finne disse ved å klikke"
									},
									{
										"bold": "Konfigurasjon → Betalingsmetoder"
									}
								],
								[
									{
										"text": "Åpne Klarna Checkout-tilgangen og aktiver den ved å klikke"
									},
									{
										"bold": "Aktivert"
									},
									{
										"text": "i avkryssingsboksen. Lagre endringene dine."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Konfigurer fraktkostnadene dine",
							"step_instructions": [
								[
									{
										"text": "Konfigurer fraktkostnadene for din Klarna Checkout ved å klikke"
									},
									{
										"bold": "Konfigurasjon → Fraktkostnad"
									}
								],
								[
									{
										"text": "Velg fraktmetoden som skal være tilgjengelig for Klarna ved å klikke på"
									},
									{
										"bold": "blyantikonet."
									}
								],
								[
									{
										"text": "Velg tabellen Betalingsmåte og flytt Klarna Checkout fra"
									},
									{
										"bold": "Tilgjengelig"
									},
									{
										"text": "til"
									},
									{
										"bold": "Valgt"
									},
									{
										"text": "Lagre dine innstillinger"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Aktiver din Klarna Checkout-plugin",
							"step_instructions": [
								[
									{
										"text": "Deretter må du aktivere din Klarna Checkout plugin. Klikk deg gjennom"
									},
									{
										"bold": "Konfigurasjon → Administrer programtillegg → Installert"
									},
									{
										"text": "for å finne Plugin Manager."
									}
								],
								[
									{
										"text": "Aktiver plugin ved å klikke på"
									},
									{
										"bold": "rød \"X\""
									},
									{
										"text": "-ikonet"
									}
								],
								[
									{
										"text": "Du vil bli spurt om du vil tømme hurtigbufferen. Klikk på"
									},
									{
										"bold": "Ja."
									}
								],
								[
									{
										"text": "For å aktivere Klarna Checkout programtillegg fullt ut, må butikkens tema kompileres på nytt. Klikk på"
									},
									{
										"bold": "Kompilere temaer"
									},
									{
										"text": "når du blir spurt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Siste trinn",
							"step_instructions": [
								[
									{
										"text": "For å unngå avrundingsfeil, må du sørge for at PHP-utvidelsen bcmath er installert på serveren. Du finner veiledningen"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "her"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Pass på at \"Tilleggsadresse 1\" og \"Tilleggsadresse 2\" ikke er merket som obligatorisk."
									}
								],
								[
									{
										"text": "Start på nytt med en gang for å sikre at alle konfigurasjoner er tilgjengelige i butikken din."
									}
								],
								[
									{
										"text": "Du må forsikre deg om at Klarna Checkout vises som forventet ved å legge til et element i handlekurven din, velge Klarna som betalingsmetode, og fortsett til kassen (Ikke fullfør bestillingen)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Aktiver programtillegget for Klarnas betalingsmetode på Shopware",
							"step_instructions": [
								[
									{
										"text": "For å kunne installere Klarna programtillegg trenger du et system som kjører med Shopware 6. Retningslinjer for installasjon finner du"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "her."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Installering og oppsett. Det er flere måter å installere Klarna programtillegg på.",
							"step_instructions": [
								[
									{
										"text": "Først, kjør veiviseren."
									}
								],
								[
									{
										"text": "Installasjon via administrasjon."
									}
								],
								[
									{
										"text": "Installasjon via Community Store Direct Download."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Aktiver Klarnas betalingsmetode-programtillegget for Shopware",
							"step_instructions": [
								[
									{
										"text": "Gå til oversikten over programtilleggene i Shopware Administration. Du får tilgang til dette via"
									},
									{
										"bold": "Innstillinger > System > Programtillegg."
									}
								],
								[
									{
										"text": "Velg"
									},
									{
										"bold": "Installer"
									},
									{
										"text": "fra hurtigmenyen (\"...\"). Du vil motta en melding fra Shopware om at programtillegg er installert."
									}
								],
								[
									{
										"text": "Av sikkerhetsgrunner er programtillegget nå installert, men ennå ikke aktivert. Du må optimalisere det med tilgangsdataene og individuelle innstillinger først."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Veiviser",
							"step_instructions": [
								[
									{
										"text": "Etter at programtillegget er aktivert, gå til"
									},
									{
										"bold": "hurtigmeny («...») > veiviser.",
										"text": "Du vil da bli sendt videre til rutinen."
									}
								],
								[
									{
										"text": "Rutinen vil lede deg gjennom hele installasjonsprosessen og gir registrering hos Klarna hvis du ennå ikke har en forhandlerkonto."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Konfigurasjon av programtillegg",
							"step_instructions": [
								[
									{
										"bold": "Salgskanaler."
									},
									{
										"text": "Her bestemmer du om følgende innstillinger for \"alle salgskanaler\" skal forbli, eller kun gjelde for enkelte individuelle salgskanaler."
									}
								],
								[
									{
										"bold": "Innstillinger for programmeringsgrensesnitt (API)."
									},
									{
										"text": "Brukernavn og passord for programmeringsgrensesnitt (API): Oppgi brukernavn og passord for programmeringsgrensesnitt (API) her for live- og testmodus i de aktuelle seksjonene."
									}
								],
								[
									{
										"text": "Du kan teste brukernavn og passord til programmeringsgrensesnitt i Klarna (API) ved å klikke på"
									},
									{
										"bold": "Test brukernavn og passord til programmeringsgrensesnitt (API)",
										"text": "-knappen, som du finner i overskriften. Du vil da motta en melding eller en indikasjon på hvilke data som ser ut til å være feil."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Aktiver / deaktiver programtillegg",
							"step_instructions": [
								[
									{
										"text": "Hvis du vil aktivere/deaktivere programtillegget for Klarnas betalingsmetode, eller bare vil se gjeldende aktiveringsstatus, går du til Shopware Admin og velger"
									},
									{
										"bold": "Innstillinger > System > Programtillegg."
									}
								],
								[
									{
										"text": "Her finner du gjeldende status i tabellen under"
									},
									{
										"bold": "\"Mine programtillegg\"."
									}
								],
								[
									{
										"text": "Statusen kan endres ved å klikke på glidebryteren."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						},
						{
							"title": "Siste trinn",
							"step_instructions": [
								[
									{
										"text": "For å unngå avrundingsfeil må du sørge for at du har PHP-versjonen  >= 7.2."
									}
								],
								[
									{
										"text": "Fullfør installasjon av Shopware"
									},
									{
										"bold": "(Butikk og administrasjon, ikke trådløs)."
									}
								],
								[
									{
										"text": "Systemet må være tilgjengelig utenfra for å oppdatere betalingsstatus."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For mer detaljert informasjon om integrering av Shopware, se den"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "utvidede guiden. (På tysk)"
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For å få mer detaljert informasjon om 3dcart-integrasjonen, følg"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						},
						{
							"title": "Aktiver Klarnas betalingsmetode i butikkdrift på nett",
							"step_instructions": [
								[
									{
										"text": "Logg inn på"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager,"
									},
									{
										"text": "og gå til"
									},
									{
										"bold": "Settings → Payment."
									}
								],
								[
									{
										"text": "På betalingssiden, klikk på"
									},
									{
										"bold": "Velg betalingsmetoder"
									},
									{
										"text": "-knappen."
									}
								],
								[
									{
										"text": "Du får se en liste over forhåndsinstallerte moduler. Finn Klarna-modulen og aktiver den med vippebryteren."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For å få mer detaljert informasjon om 3dcart-integrasjonen, følg"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						},
						{
							"title": "Oppgi brukernavn og passord for programmeringsgrensesnitt (API) i Klarna",
							"step_instructions": [
								[
									{
										"text": "Etter at du har aktivert modulen, angir du Klarna API-brukernavnet (UID) i det angitte feltet. Du finner dette i legitimasjonsfilen du lastet ned tidligere."
									}
								],
								[
									{
										"text": "Klikk deretter på"
									},
									{
										"bold": "Link til endring av passord"
									},
									{
										"text": "og skriv inn Klarna API-passord i passordfeltet."
									}
								],
								[
									{
										"text": "Under"
									},
									{
										"bold": "Språkland"
									},
									{
										"text": "velg landets språk som skal brukes til betalingsalternativene for Klarna i butikken."
									}
								],
								[
									{
										"text": "Over feltet for brukernavn finner du en avkrysningsrute merket"
									},
									{
										"bold": "\"Testmodus\"."
									},
									{
										"text": "Huk av dette alternativet for å aktivere testmodus, slik at du kan legge inn bestillinger uten å måtte betale mens du tester modulen."
									}
								],
								[
									{
										"text": "Når du er ferdig med å konfigurere innstillingene, klikker du på \"Lagre\" øverst til høyre."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For å få mer detaljert informasjon om 3dcart-integrasjonen, følg"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						},
						{
							"title": "Legg inn et prøvekjøp",
							"step_instructions": [
								[
									{
										"text": "For å bekrefte at integrasjonen er riktig konfigurert, legg inn prøvekjøp i butikken din."
									}
								],
								[
									{
										"text": "Etter å ha lagt inn bestillingen, gå til"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordre i Merchant Portal,"
									},
									{
										"text": "finn bestillingen din og kanseller den for å unngå å betale for den selv."
									}
								],
								[
									{
										"text": "Når integreringen er vellykket, blir banneret øverst på denne siden grønt og viser ordene \"Integrasjon fullført\"."
									}
								],
								[
									{
										"text": "Hvis du aktiverte \"Testmodus\" i forrige trinn, gå tilbake og fjern markeringen og lagre det før du går live med butikken din, slik at de reelle ordrene dine vil gå gjennom."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "For å få mer detaljert informasjon om 3dcart-integrasjonen, følg"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "utvidede integrasjonsveiledningen."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							],
							"alternate": [
								{
									"text": "For mer detaljert informasjon om BigCommerce-integreringen din, følg"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "utvidede integrasjonsveiledningen."
								}
							]
						},
						{
							"title": "Konfigurer innstillingene for BigCommerce",
							"step_instructions": [
								[
									{
										"text": "I BigCommerce, gå til"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Store Setup › Payments,"
									},
									{
										"text": "og utvid delen for online betalingsmetoder. Klikk deretter"
									},
									{
										"bold": "Oppsett"
									},
									{
										"text": "videre til Klarnas betalingsmetode."
									}
								],
								[
									{
										"text": "Du omdirigeres til innstillinger for Klarnas betalingsmetode. Angi filen for brukernavn og passord til API. Det er den du lagret i forrige økt. Kopier brukernavn og passord til riktige felt."
									}
								],
								[
									{
										"text": "Lagre endringene når du er klar."
									}
								]
							],
							"alternate": [
								{
									"text": "For mer detaljert informasjon om BigCommerce-integreringen din, følg"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "utvidede integrasjonsveiledningen."
								}
							]
						},
						{
							"title": "Legg inn et prøvekjøp",
							"step_instructions": [
								[
									{
										"text": "For å bekrefte at integrasjonen er riktig konfigurert, legg inn prøvekjøp i butikken din."
									}
								],
								[
									{
										"text": "Etter å ha lagt inn bestillingen, gå til"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordre i Merchant Portal,"
									},
									{
										"text": "finn bestillingen din og kanseller den for å unngå å betale for den selv."
									}
								],
								[
									{
										"text": "Når integreringen er vellykket, blir banneret øverst på denne siden grønt og viser ordene \"Integrasjon fullført\"."
									}
								]
							],
							"alternate": [
								{
									"text": "For mer detaljert informasjon om BigCommerce-integreringen din, følg"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "utvidede integrasjonsveiledningen."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Aktiver Klarna Checkout modul",
							"step_instructions": [
								[
									{
										"text": "Først må du sørge for at du har installert den offisielle Klarna-modulen for Prestashop. Hvis du ikke har det ennå, kan du gå til"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								],
								[
									{
										"text": "Fra og med 1. januar 2023 vil disse plugin-modulene, utviklet og eid av Prestasworks A.B (SI), dessverre ikke lenger distribueres gratis. Hvis du er interessert i Klarna, kan du kjøpe plugin-modulen eller vente på Klarna-eide plugin-moduler som forventes å slippes i 2. kvartal av 2023."
									}
								],
								[
									{
										"text": "Logg deg på admin i Prestashop, og gå til"
									},
									{
										"bold": "Moduler → Moduler."
									}
								],
								[
									{
										"text": "Oppgi «Klarna» i søkefeltet for å finne Klarna-modulen av Prestaworks AB. Klikk"
									},
									{
										"bold": "Konfigurer."
									}
								]
							]
						},
						{
							"title": "Konfigurer innstillingene for Klarna",
							"step_instructions": [
								[
									{
										"text": "Du er nå på siden med modulinnstillinger. Øverst i «generelle innstillinger» vil du se en knapp for"
									},
									{
										"bold": "Aktiver KCO i denne butikken"
									},
									{
										"text": "(Klarna Checkout V3). Velg"
									},
									{
										"bold": "Ja."
									}
								],
								[
									{
										"text": "Klikk"
									},
									{
										"bold": "Lagre"
									},
									{
										"text": "for å lagre innstillingene."
									}
								],
								[
									{
										"text": "Klikk nå på salgslandet i menyen til venstre, og oppgi brukernavn og passord for programmeringsgrensesnitt (API) i Klarna under"
									},
									{
										"bold": "Brukernavn for programmeringsgrensesnitt (API) i Klarna"
									},
									{
										"text": "og"
									},
									{
										"bold": "Passord for programmeringsgrensesnitt (API) i Klarna."
									}
								],
								[
									{
										"text": "Klikk"
									},
									{
										"bold": "Lagre."
									}
								]
							]
						},
						{
							"title": "Siste trinn",
							"step_instructions": [
								[
									{
										"text": "Kontroller at testmodus er deaktivert hvis du er klar til å gå live med nettstedet. Du kan gjøre det under fanen"
									},
									{
										"bold": "Vanlige innstillinger."
									},
									{
										"text": "Knappen"
									},
									{
										"bold": "Prøvekjøring"
									},
									{
										"text": "bør settes til"
									},
									{
										"bold": "Nr."
									}
								],
								[
									{
										"text": "Mens under"
									},
									{
										"bold": "Vanlige innstillinger,"
									},
									{
										"text": "se til at du setter opp innstillingene etter hvordan du vil håndtere ordre, innstillinger for fakturautsendelser osv."
									}
								],
								[
									{
										"text": "Sørg for at Klarna Checkout vises som forventet ved å legge til en vare i handlekurven og fortsette til checkout (Ikke fullfør bestillingen)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							]
						},
						{
							"title": "Installer og aktiver modulen for Klarnas betalingsmetode",
							"step_instructions": [
								[
									{
										"text": "Åpne"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Side med instruksjoner for Klarnas betalingsmetode på Prestashop"
									},
									{
										"text": "og følg instruksjonene der for å installere og konfigurere modulen på Prestashop-kontoen din."
									}
								]
							]
						},
						{
							"title": "Legg inn et prøvekjøp",
							"step_instructions": [
								[
									{
										"text": "For å bekrefte at integrasjonen er riktig konfigurert, legg inn prøvekjøp i butikken din."
									}
								],
								[
									{
										"text": "Etter å ha lagt inn bestillingen, gå til"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordre i Merchant Portal,"
									},
									{
										"text": "finn bestillingen din og kanseller den for å unngå å betale for den selv."
									}
								],
								[
									{
										"text": "Når integreringen er vellykket, blir banneret øverst på denne siden grønt og viser ordene \"Integrasjon fullført\"."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Få brukernavn og passord for programmeringsgrensesnitt (API) i Klarna.",
							"step_instructions": [
								[
									{
										"text": "Du trenger denne legitimasjonen for å integrere Klarna i butikken din."
									}
								]
							]
						},
						{
							"title": "Legg til Klarna som ny betalingsmetode.",
							"step_instructions": [
								[
									{
										"text": "Gå til Jumpseller Admin Panel og naviger til Innstillinger > Betalinger, finn avkrysningsboksen \"Klarna\" i listen og klikk \"Legg til metode\"."
									}
								]
							]
						},
						{
							"title": "Konfigurer vår nye betalingsmetode.",
							"step_instructions": [
								[
									{
										"text": "På Klarna-konfigurasjonspanelet (Jumpseller Admin Panel og naviger til Innstillinger > Betalinger > Klarna), (i) legg til Klarna API-legitimasjonen generert på første trinn, (ii) velg EMD-pakkene du vil/trenger å dele med Klarna, og ( iii) velg om du trenger å automatisk levere ordrene (standard er nei)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integrer Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Se integrasjonsveiledningen i"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Engelsk"
									},
									{
										"text": "og i"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Nederlandsk"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integrer Shoper",
							"step_instructions": [
								[
									{
										"text": "Se integrasjonsveiledningen på"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "Shoper-nettstedet"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integrer Timma",
							"step_instructions": [
								[
									{
										"text": "Se integrasjonsveiledningen på"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "Timma-nettsiden"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							]
						},
						{
							"title": "Integrer med SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Følg instruksjonene på"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "SmartEtailings nettside."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Generer og lagre Klarna API-legitimasjonen",
							"step_instructions": [
								[
									{
										"text": "Generer ny API-legitimasjon og last ned filen til datamaskinen din. Åpne filen og hold den åpen, da du trenger API-legitimasjonen i neste avsnitt."
									}
								]
							]
						},
						{
							"title": "Integrer med Workstand",
							"step_instructions": [
								[
									{
										"text": "Følg instruksjonene på"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "Workstand nettside."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Les dokumentasjonen for vår plugin",
							"step_instructions": [
								[
									{
										"text": "Gå til vår"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "dokumentasjonsside"
									}
								]
							]
						},
						{
							"title": "Aktiver Klarna Checkout-modulen for JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Sørg for at du har installert den offisielle Klarna-utvidelsen. Hvis du ikke har det ennå,"
									},
									{
										"text": "gå til"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Les dokumentasjonen for vår plugin",
							"step_instructions": [
								[
									{
										"text": "Gå til vår"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "dokumentasjonsside"
									}
								]
							]
						},
						{
							"title": "Aktiver Klarna Payments-modulen for JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Sørg for at du har installert den offisielle Klarna-utvidelsen. Hvis du ikke har det ennå,"
									},
									{
										"text": "gå til"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "denne siden"
									},
									{
										"text": "for å få den."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Her er det neste du må gjøre",
							"step_instructions": [
								[
									{
										"bold": "Få brukernavn og passord for programmeringsgrensesnitt (API) i Klarna."
									},
									{
										"text": "Du trenger disse for å integrere Klarna i butikken"
									}
								],
								[
									{
										"bold": "Legg til Klarna brukernavn og passord for programmeringsgrensesnitt (API) i backend for å aktivere Klarna."
									},
									{
										"text": "Se vår"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "utviklerportal"
									},
									{
										"text": "for mer støtte."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Fornavn",
							"error": "Oppgi et fornavn"
						},
						"last_name": {
							"label": "Etternavn",
							"error": "Oppgi et etternavn"
						},
						"dateOfBirth": {
							"label": {
								"default": "Fødselsdato (DD/MM/ÅÅÅÅ)",
								"without_format": "Fødselsdato",
								"US": "Fødselsdato (MM/DD/ÅÅÅÅ)"
							},
							"error": "Oppgi en gyldig dato",
							"error_too_young": "Du må være minst 18 år for å selge med Klarna"
						},
						"address": {
							"label": "Bostedsadresse",
							"error": "Oppgi bostedsadressen"
						},
						"city": {
							"label": "By/sted",
							"error": "Oppgi en by"
						},
						"country": {
							"label": "Land",
							"error": "Vennligst velg land"
						},
						"postal_code": {
							"label": {
								"default": "Postnummer",
								"US": "Postnummer"
							},
							"error": {
								"default": "Oppgi et gyldig postnummer",
								"US": "Oppgi et gyldig postnummer"
							}
						},
						"region": {
							"label": "Stat / region (valgfritt)",
							"label_summary": "Stat / region"
						},
						"state": {
							"label": "Delstat",
							"error": "Oppgi en stat"
						},
						"role_question": {
							"OWNER": "Er denne personen en eier?",
							"BENEFICIAL_OWNER": "Kontrollerer denne personen mer enn 25 % av aksjene eller stemmeretten?",
							"ULTIMATE_BENEFICIAL_OWNER": "Denne personen eier eller kontrollerer mer enn 25 % av aksjene eller stemmeretten"
						},
						"is_person_pep": [
							{
								"text": "Er denne personen en"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "politisk utsatt person (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "i nærmeste familie"
							},
							{
								"text": "eller"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "kjent medarbeider"
							},
							{
								"text": "av en slik person?"
							}
						],
						"pep_relationship": {
							"label": "Relasjon",
							"error": "Velg forholdet denne personen har til en PEP"
						},
						"pep_position": {
							"label": "PEP-posisjon",
							"error": "Velg stillingen PEP har"
						},
						"personal_id_question": "Denne personen har ikke et personnummer",
						"personal_id": {
							"US": {
								"label": "Personnummer (siste 4 sifre)",
								"label_summary": "Personnummer"
							},
							"US_FULL_SSN": {
								"label": "Personnummer",
								"label_summary": "Personnummer"
							},
							"CA": {
								"label": "SIN-nummer eller passnummer",
								"label_summary": "SIN-nummer eller passnummer"
							},
							"SE": {
								"label": "Personnummer (PNO)",
								"label_summary": "Personnummer (PNO)"
							},
							"FI": {
								"label": "Personnummer (HETU)",
								"label_summary": "Personnummer (HETU)"
							},
							"NO": {
								"label": "Personnummer",
								"label_summary": "Personnummer"
							},
							"DK": {
								"label": "Personnummer",
								"label_summary": "Personnummer (CPR)"
							},
							"IT": {
								"label": "Skattekode",
								"label_summary": "Skattekode"
							},
							"ES": {
								"label": "Personnummer",
								"label_summary": "Personlig identifikasjonsnummer (DNI)"
							},
							"PL": {
								"label": "Personnummer",
								"label_summary": "Personnummer (PESEL)"
							},
							"default": {
								"label": "Passnummer",
								"label_summary": "Passnummer"
							},
							"value": "Konfidensielt"
						},
						"registration_number": {
							"label": "Organisasjonsnummer",
							"error": "Oppgi EIN i formatet: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Butikknavn",
							"error": "Oppgi et gyldig virksomhetsnavn"
						},
						"legal_company_name": {
							"label": "Selskapets juridiske navn",
							"error_label": "Vennligst oppgi firmaets juridiske navn"
						},
						"add_person": "Legg til person",
						"remove": "Fjern",
						"edit": "Endre"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Forhandler-ID: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Markedsføringsmateriale",
						"text": "Nå er du en del av familien Klarna. Her er en pakke med materialer og mer, for å komme i gang.",
						"link": "Last ned"
					},
					"invite_more_users": {
						"title": "Inviter flere brukere",
						"text": "Inviter dine medarbeidere til selgerportalen, du vil kunne sette tilpassede tillatelser for hver av dem!",
						"link": "Inviter brukere"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produkter og priser",
					"subtitle": "{country}",
					"pricing": "Priser for {country}",
					"monthly_fee": "månedlig avgift",
					"transaction_fee": "transaksjonsgebyr",
					"before_link": "Jeg er enig i Klarnas",
					"link_text": "Vilkår og betingelser",
					"after_link_one_product": "for dette produktet",
					"after_link_more_than_one_product": "for disse produktene",
					"product_not_available_in_your_country": "* Dette produktet finnes ikke i dette markedet, men det vil fungere i andre land."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Installert"
						},
						"in_progress": {
							"text": "Pågående"
						}
					}
				},
				"phone_collection_block": {
					"title": "Har du problemer med Klarna-integrasjonen?",
					"description": "Legg igjen nummeret ditt nedenfor, så vil en av våre agenter ringe og hjelpe deg med å legge til Klarna.",
					"success_banner": "Takk! Teamet vårt kommer tilbake til deg så fort som mulig.",
					"submit": "Send",
					"fields": {
						"phone": {
							"label": "Telefonnummer",
							"tooltip": "Du må inkludere landskoden, f.eks. +1 541 754 3010",
							"errors": {
								"required": "Telefonnummer er påkrevd",
								"invalid": "Ugyldig telefonnummer"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Hvem signerer kontraktene for selskapet ditt?",
						"managed": "Hvem signerer kontraktene for selskapet?",
						"recollection": "Hvem er autorisert til å signere på vegne av virksomheten din?"
					},
					"subtitle": {
						"unmanaged": "Virksomheten din er i ferd med å inngå en kontrakt med Klarna. Vi må verifisere hvem som er lovlig autorisert til å signere kontrakter.",
						"managed": "Vennligst oppgi informasjonen om alle autoriserte ledere i virksomheten som sender inn avtalen. Vi er juridisk pålagt å validere signaturmyndigheten til disse representantene. Hvis ingen fra listen undertegnet avtalen, klikker du på «legg til person» og oppgir obligatorisk informasjon.",
						"recollection": "Ettersom bedriften din har en aktiv avtale med Klarna, er vi juridisk forpliktet til å samle inn og verifisere informasjon om alle dine juridiske representanter."
					},
					"form_title": "Oppgi informasjonen",
					"robot_message": {
						"unmanaged": "Dette er vanligvis styret eller ledere som konsernsjef, finansdirektør eller administrerende direktør. Å legge inn to eller flere personer kan bidra til kortere godkjenningsprosess.",
						"managed": "Dette er vanligvis styret eller ledere som konsernsjef, finansdirektør eller administrerende direktør. Å legge inn to eller flere personer kan bidra til kortere godkjenningsprosess."
					},
					"error_tooltip": {
						"too_young": "Denne personen kan ikke sende inn søknaden fordi vedkommende er under {minAge} år."
					},
					"alert_all_too_young": "Alle personer som inngår avtalen må være over {minAge} år. For å fortsette, legg til og velg en søker som er over {minAge} år gammel.",
					"buttons": {
						"next": "Neste",
						"back": "Tilbake",
						"add_person": "+ Legg til person"
					},
					"role": {
						"recollection": "Juridisk representant"
					}
				},
				"application_summary": {
					"title": "Gå gjennom og send inn søknaden din.",
					"subtitle": {
						"unmanaged": "Se over informasjonen før du sender inn.",
						"managed": "Se over informasjonen før du sender inn."
					},
					"stakeholders": {
						"title": "Bedriftsledelse",
						"subtitle": "Interessent {index}"
					},
					"businessDetailsCard": {
						"title": "Bedriftsformasjon"
					},
					"businessDetailsCardFields": {
						"companyName": "Virksomhetens navn",
						"organizationEntityType": "Skatteklassifisering",
						"organizationRegistrationAuthority": "Tinglysingsdomstol",
						"goodsCategory": "Varekategori",
						"registrationId": {
							"default": "Registreringsnummer",
							"AT": "Registreringsnummer",
							"AU": "ACN",
							"CA": "Forretningsnummer",
							"ES": "Firma-NIF/NIE/DNI",
							"GB": "Organisasjonsnummer",
							"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
							"NZ": "Forretningsnummer",
							"US": "Arbeidsgivers identifikasjonsnummer"
						},
						"registered": {
							"default": "Registrert virksomhet",
							"AU": "Virksomheten har et ACN"
						},
						"subjectToVat": {
							"default": "Momspliktig virksomhet",
							"AU": "Virksomhet underlagt ABN"
						},
						"vatId": {
							"default": "MVA-nummer",
							"AU": "ABN",
							"NZ": "GST-nummer",
							"ES": "Firma-NIF/NIE/DNI"
						},
						"storeName": "Butikknavn",
						"storeName_us": "Merkenavn / DBA",
						"website": "Nettsted",
						"email": "E-post til kundestøtte",
						"entityType": "Enhetstype"
					},
					"companyRegistrationAddressCard": {
						"title": "Virksomhetens registrerte adresse"
					},
					"companyAddressCard": {
						"title": "Virksomhetsadresse"
					},
					"operatingAddressCard": {
						"title": "Adresse til virksomhetens hovedkontor"
					},
					"documentsCard": {
						"title": "Opplastede dokumenter"
					},
					"buttons": {
						"edit": "Endre",
						"back": "Tilbake",
						"submit": "Send inn"
					},
					"noTermsAccepted": "Les og godkjenn vilkår og betingelser",
					"noTermsAcceptedWithPricingAnnex": "Les og godkjenn forhandleravtalen og prisbetingelser"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Hvem leder denne virksomheten?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi er lovpålagt av EUs direktiv om bekjempelse av hvitvasking ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						],
						"US": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"CA": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"AU": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						]
					},
					"infobox": {
						"default": "Skriv inn personopplysningene og bostedsadressen til selskapets administrerende direktør.",
						"US": "Vennligst skriv inn personopplysningene og bostedsadressen til majoritetseieren eller en høytstående leder som konsernsjef, økonomidirektør eller COO.",
						"CA": "Vennligst skriv inn personopplysningene og bostedsadressen til majoritetseieren eller en høytstående leder som konsernsjef, økonomidirektør eller COO."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Er denne virksomheten en offentlig virksomhet eller utelukkende eid av en offentlig virksomhet?",
					"title_stakeholder": "Hvem leder denne virksomheten?",
					"subtitle": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen.",
					"subtitle_stakeholder": "Skriv inn personopplysningene og bostedsadressen til selskapets administrerende direktør.",
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"bank_account": {
					"title": {
						"default": "Hva er kontoinformasjonen din?"
					},
					"subtitle": {
						"US": "Transaksjoner fra Klarna vil bli overført til denne bankkontoen.",
						"default": "Vi bruker disse bankkontoopplysningene for å overføre betalingene fra salget."
					},
					"no_more_bank_accounts": "Du har allerede lagt til bankkontoer for alle valutaer vi opererer med. Flott!",
					"robot_message_general": "Standard bankkonto må være hos en bank i landet der virksomheten er registrert. Du må også ha en bankkonto for hver av valutaene du planlegger å godta.",
					"robot_message": "IBAN er et internasjonalt bankkontonummer og tildeles til kontoen av banken. F.eks.: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Kontonummer leveres av banken din og består av 6 - 10 sifre. F.eks: 12345678",
						"US": "Kontonummer leveres av banken din og består av 5 - 17 sifre. F.eks: 12345678",
						"GB": "Kontonummer oppgis av banken din og har 8 sifre. For eksempel: 12345678. Noen banker i Storbritannia tilbyr kortere kontonumre (dvs. 7 sifre). I dette tilfellet vil nuller bli lagt til i starten av nummeret ditt for å gjøre lengden opp til 8."
					},
					"robot_message_revolut": "IBAN-nummeret du oppga, kan ikke motta innenlandske GBP-betalinger. Du må kontakte banken og be om kontoinformasjon som støtter innenlandske GBP-overføringer.",
					"robot_message_local": "IBAN som du oppga er et lokalt IBAN for banken din som ikke støttes av oss. Du må kontakte banken din og be om ditt personlige IBAN eller bruke en annen konto for å koble til Klarna.",
					"buttons": {
						"add_bank_account": "+ Legg til bankkonto",
						"skip": "Hopp over (for nå)",
						"remove": "Fjern",
						"submit": "Send inn",
						"next": "Neste",
						"back": "Tilbake"
					},
					"fields": {
						"currency_code": {
							"label": "Valuta",
							"disable_reason": {
								"account_in_merchant_currency_required": "Standardvalutaen er {currency} fordi bedriften din er registrert i."
							},
							"errors": {
								"general": "Vennligst velg valuta"
							}
						},
						"country_of_bankaccount": {
							"label": "Land",
							"errors": {
								"general": "Vennligst velg land"
							}
						},
						"iban_account_number": {
							"label": "Kontonummer (IBAN)",
							"errors": {
								"general": "Vennligst legg inn bankkontonummer (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Bruk denne kontoen for uspesifiserte valutaer",
							"tooltip": "Bestillinger med valutaer som ikke er oppført på denne siden vil bli utbetalt til denne kontoen. Banken din kan kreve et tilleggsgebyr for enkelte valutaer."
						},
						"local_account_number": {
							"label": {
								"default": "Kontonummer",
								"MX": "CLABE-nummer"
							},
							"errors": {
								"general": {
									"default": "Vennligst oppgi et kontonummer",
									"MX": "Vennligs oppgi et gyldig CLABE-nummer"
								}
							}
						},
						"account_holder": {
							"label": "Navn på kontoinnehaver",
							"errors": {
								"general": "Angi navn på kontoinnehaveren (maksimalt 70 tegn)."
							}
						},
						"transit_number": {
							"label": "Transittnummer",
							"errors": {
								"general": "Oppgi et gyldig transittnummer"
							}
						},
						"institution_number": {
							"label": "Institusjonsnummer",
							"errors": {
								"general": "Oppgi et gyldig Institusjonsnummer"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Vennligst oppgi en gyldig BSB (bankstatsfilial)"
								}
							},
							"tooltip": {
								"AU": "BSB-koden skal bestå av 6 numeriske sifre delt av en «-». F.eks.: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Rutingnummer",
								"GB": "Sorteringskode"
							},
							"errors": {
								"general": {
									"default": "Vennligst legg inn gyldig rutingnummer",
									"GB": "Skriv inn en gyldig sorteringskode"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Hvem leder denne virksomheten?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi er lovpålagt av EUs direktiv om bekjempelse av hvitvasking ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						],
						"GB": [
							{
								"text": "Vi er juridisk pålagt til å samle inn og bekrefte denne informasjonen. Se til at all informasjon i Companies House er oppdatert."
							}
						]
					},
					"infobox": "Vennligst skriv inn personlig informasjon og bostedsadresse til enkeltpersoner som utøver kontroll over selskapets ledelse, for eksempel administrerende direktør eller styremedlemmer.",
					"buttons": {
						"next": "Neste",
						"back": "Tilbake",
						"add_person": "+ Legg til person"
					},
					"messages": {
						"lookup": "Styrer disse personene virksomheten? Se over og bekreft om det er riktig."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Er virksomheten registrert?",
						"managed": "Er denne virksomheten registrert?"
					},
					"subtitle": {
						"unmanaged": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
						"managed": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene."
					},
					"question": {
						"title": {
							"unmanaged": "Oppgi registreringsnummeret og registreringsretten",
							"managed": "Oppgi registreringsnummeret og registreringsretten"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Registreringsnummer"
						},
						"registration_court": {
							"label": "Registreringsinstans",
							"errors": {
								"general": {
									"unmanaged": "Vennligst oppgi registreringsinstans",
									"managed": "Velg registreringsdomstol"
								}
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"documents": {
					"title": "Last opp vedleggene",
					"subtitle": "Vi krever at du sender oss noen få tilleggsdokumentasjoner som trengs for at vi skal kunne bekrefte identiteten din. Last kun opp <strong>JPG</strong>, <strong>PNG</strong> eller <strong>PDF</strong>-filer (maksimal filstørrelse 10 MB).",
					"subheadline": {
						"default": "Siden Klarna er en bank med hovedkontor i Svergie, er vi derfor regulert under kontroll av det svenske finanstilsynet og av den grunn må vi overholde EU*s regelverk EU 2015/849. For å ta i bruk Klarnas tjenester, krever vi derfor å motta informasjon om personene som kontrollerer selskapet. Vennligst oppgi dokumenter som validerer deres identitet og tilnknytning til selskapet. Godkjente filer <strong>JPG, PNG or PDF</strong> filer (maximum fil størrelse 10 MB)",
						"US": "Ettersom Klarna er en bank med hovedkontor i Sverige, og derfor registrert under Finansinspektionen (Swedish Financial Supervisory Authority), må Klarna overholde EU-direktiv EU 2015/849. Klarna er påkrevd å innhente informasjon om personene som kontrollerer selskapet, slik at du kan begynne å bruke Klarnas tjenester. Oppgi følgende dokumentasjon slik at vi kan validere identiteten din. Last kun opp JPG-, PNG- eller PDF-filer (maksimal filstørrelse 10 MB).",
						"IT": "Ettersom Klarna er en bank med hovedkontor i Sverige, og derfor registrert under Finansinspektionen (Swedish Financial Supervisory Authority), må Klarna overholde EU-direktiv EU 2015/849. Klarna må innhente informasjon om personene som kontrollerer selskapet, slik at du kan begynne å bruke Klarnas tjenester. Vær oppmerksom på at for å kunne fortsette med søknaden, må selskapet ditt være registrert hos Handelskammeret (Chamber of Commerce). Last kun opp JPG-, PNG- eller PDF-filer (maksimal filstørrelse 10 MB)."
					},
					"header_title": "Dokumenter",
					"stakeholder": "Interessent",
					"business_documents": "Firmaattest",
					"browse_files": "Bla gjennom filer",
					"optional": "(valgfritt)",
					"upload_area": {
						"title": {
							"before_link": "Slipp filene dine her eller",
							"link_text": "Velg filer"
						},
						"description": "{acceptedFileFormats} - Maksimalt {maxFileSizeMB} MB / fil"
					},
					"description": {
						"APPROVAL": "Last opp <strong>godkjenning</strong>",
						"CONTRACT": "Last opp <strong>kontrakt</strong>",
						"CORRECTION_NOTE": "Last opp <strong>rettelsesnotat</strong>",
						"COUNTERSIGNED_CONTRACT": "Last opp <strong>kontrasignert kontrakt</strong>",
						"ID_DOCUMENT": "Last opp <strong>ID</strong> eller <strong>pass</strong>",
						"LICENSE": "Last opp <strong>lisens</strong>",
						"PROOF_OF_ADDRESS": "Last opp <strong>adressebevis</strong>",
						"SPECIAL_AGREEMENT": "Last opp <strong>spesialavtale</strong>",
						"SUPPORTING_DOCUMENT": "Last opp <strong>støttedokument</strong>",
						"TAX_OFFICE_REGISTRATION": "Last opp <strong>skattekontorregistrering</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Godkjenning"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Kontrakt"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Korreksjonsmerknad"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Kontrasignert kontrakt"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "identifikasjons bevis",
								"IT": "Identitetskort"
							},
							"subtitle": {
								"default": "Vennligst last opp begge sider av det gyldige ID kortet.",
								"AT": "Oppgi begge sider av ID-kortet ditt. Hvis adressen ikke er på ID-en vil vi trenge ytterligere dokumentasjon, som for eksempel en fast regning, for å verifisere adressen din.",
								"AU": "For en raskere vurdering av adressen din, oppgi en kopi av en gyldig foto-ID, så som et pass eller et australsk førerkort for følgende enkeltpersoner tilknyttet virksomheten: Selvstendig næringsdrivende / partnerskap – eieren(e). Selskap – den juridiske representanten, alle styremedlemmer og enhver aksjonær som eier mer enn 25 % av aksjene.",
								"BE": "Oppgi begge sider av identitetskortet, sørg for at bildekvaliteten er tilstrekkelig og at all informasjon er lesbar.",
								"DE": "Oppgi begge sider av ID-kortet ditt. Hvis adressen ikke er på ID-en vil vi trenge ytterligere dokumentasjon, som for eksempel en fast regning, for å verifisere adressen din.",
								"FR": "Oppgi begge sider av identitetskortet, sørg for at bildekvaliteten er tilstrekkelig og at all informasjon er lesbar.",
								"GB": "Oppgi ID, hvis et identitetskort, begge sider",
								"IT": "Forside/bakside på et gyldig identitetskort for hver av personene oppført i søknaden. Førerkort, pass, trygdekort/-nummer kan ikke aksepteres.",
								"NL": "Oppgi begge sider av identitetskortet, sørg for at bildekvaliteten er tilstrekkelig og at all informasjon er lesbar.",
								"US": "Førerkort eller pass - Oppgi begge sider av identitetskortet."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Lisens"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Personlig boadresse bevis",
								"BE": "Personlig boadresse bevis",
								"CZ": "Personlig boadresse bevis",
								"ES": "Personlig boadresse bevis",
								"FI": "Personlig boadresse bevis",
								"FR": "Personlig boadresse bevis",
								"GR": "Personlig boadresse bevis",
								"IT": "Personlig boadresse bevis",
								"NL": "Personlig boadresse bevis",
								"PL": "Personlig boadresse bevis",
								"PT": "Personlig boadresse bevis"
							},
							"subtitle": {
								"default": "Vi aksepterer følgende dokumenter som ikke er eldre enn 3 måneder som bevis på personlig boadresse: Strømregning, vann og avløps-regning, internett og tv regning, brev fra skatteetaten og leiekontrakt. Dersom du ikke har noen av de oppgitte dokument typene, kan du ta et skjermbilde av din side på altinn.no, eller laste opp et annet dokumet som viser bevis på din personlige boadresse og legge til et begrunnelsesnotat.",
								"AU": "Fo en raskere vurdering av søknaden din, oppgi ett av følgende dokumenter fra de siste 90 dagene for å verifisere hjemmeadressen: Fast regning, internettregning, selvangivelse eller lease-/leieavtale. *Hvis du oppgir et pass som din form for ID, eller hvis din nåværende adresse ikke samsvarer med adressen på den oppgitte ID-en, er dette trinnet obligatorisk.",
								"BE": "Vi aksepterer følgende dokumenter som ikke er eldre enn 3 måneder som et bevis på hjemmeadresse: Elektrisitet, vann, gass, skatteseddel eller leaseavtale. Skulle du ikke ha noen av dokumentene, last opp et hvert annet bevis på hjemmebolig og legg ved en merknad med årsaken.",
								"FR": "Vi aksepterer følgende dokumenter som ikke er eldre enn 3 måneder som et bevis på hjemmeadresse: Elektrisitet, vann, gass, skatteseddel eller leaseavtale. Skulle du ikke ha noen av dokumentene, last opp et hvert annet bevis på hjemmebolig og legg ved en merknad med årsaken.",
								"NL": "Vi aksepterer følgende dokumenter som ikke er eldre enn 3 måneder som et bevis på hjemmeadresse: Elektrisitet, vann, gass, skatteseddel eller leaseavtale. Skulle du ikke ha noen av dokumentene, last opp et hvert annet bevis på hjemmebolig og legg ved en merknad med årsaken.",
								"US": "Vi aksepterer faste regninger (strøm, vann, internett, telefon osv.), leie eller boliglån med bevis på adresse – må ikke være datert eldre enn 90 dager fra datoen på søknaden.",
								"IT": "Hvis identitetskortet ditt har en annen adresse en din nåværende boligadresse, vil vi trenge et ytterligere dokument for å verifisere din nåværende bolig. Vi aksepterer følgende dokumenter som ikke er eldre enn 3 måneder som bevis på boligadressen til personene oppført i søknaden:"
							},
							"list": {
								"IT": [
									{
										"text": "Bostedsbevis utstedt på nett (via SPID) eller av kommunen du er bosatt i"
									},
									{
										"text": "Elektrisitet- / vann- / gass- / Wi-Fi-regninger"
									},
									{
										"text": "leiekontrakt"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Spesialavtale"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Støttende dokument",
								"GB": "Selvportrett"
							},
							"subtitle": {
								"default": null,
								"AU": "Hvis du selger merkevarer av høy verdi, oppgi 2–3 leverandørfakturaer for disse produktene her. Sikre at fakturaene inkluderer produktene kjøpt, navnet på leverandøren, mottakers navn og leveringsadresse.",
								"GB": "Oppgi et selvportrettbilde som holder opp legitimasjonen."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Dokument for registrering med skattekontoret",
								"AT": "Dokument om registrering hos skattemyndighetene",
								"AU": "Forvaltningsfullmakt",
								"BE": "MVA-nummer aktivert for grensekryssende transaksjoner (VIES).",
								"DE": "Dokument om registrering hos skattemyndighetene",
								"FR": "MVA-nummer aktivert for grensekryssende transaksjoner (VIES).",
								"IT": "MVA-nummer aktivert for grensekryssende transaksjoner (VIES).",
								"NL": "MVA-nummer aktivert for grensekryssende transaksjoner (VIES).",
								"NO": "Skattekontorregistrering",
								"US": "Arbeidsgiverens ID-nummer"
							},
							"subtitle": {
								"default": null,
								"AT": "Vi aksepterer følgende dokumenter som forretningsdokumenter: Utdrag fra kommersiell oppføring / lisens for selvstendig næringsdrivende",
								"AU": "Hvis din ABN er tilknyttet et fond, oppgi en kopi av fondsdokumentet, inkludert fondsplanen. Merk at dette trinnet er obligatorisk for fond.",
								"BE": "Verifiser at MVA-nummeret er aktivert for grensekryssende transaksjoner. Dette er nødvendig selv om du kun omsetter i ditt lokale land, da Klarna er en utenlandsk enhet. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Du kan kontakte ditt lokale skattekontor for å be om en gratis VIES-aktivering av MVA-nummeret ditt.",
								"CZ": "Vi aksepterer følgende dokumenter som forretningsdokumenter: Sertifikat om registrering i Folkeregisteret, eller utdrag fra handelsregisteret for selvstendig næringsdrivende.",
								"DE": "Vi aksepterer følgende dokumenter som forretningsdokumenter: Utdrag fra kommersiell oppføring / lisens for selvstendig næringsdrivende",
								"ES": "Vi godtar følgende dokumenter som forretningsdokumenter: stiftelsesdokumenter for registrerte virksomheter; for enkeltpersonforetak - Sertifisering av sensussituasjon / Model 036 / Model 037",
								"FI": "Vi aksepterer følgende dokumenter som forretningsdokumenter: Registreringsbevis for eneforhandlere – Sertifisering av sensussituasjon / Model 036 / Model 037",
								"FR": "Verifiser at MVA-nummeret er aktivert for grensekryssende transaksjoner. Dette er nødvendig selv om du kun omsetter i ditt lokale land, da Klarna er en utenlandsk enhet. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Du kan kontakte ditt lokale skattekontor for å be om en gratis VIES-aktivering av MVA-nummeret ditt.",
								"GR": "Vi aksepterer følgende dokumenter som forretningsdokumenter: Skattekontorregistrering / Oppstart av virksomhet / Registreringsdokument for bedrift utstedt av Competent Service GEMI (Central Union of Chambers)",
								"IT": "Du kan kontakte skattemyndighetene (Agenzia delle Entrate) for å be om en gratis VIES-aktivering av MVA-nummeret ditt. Dette vil være nødvendig selv om du kun omsetter i Italia, da Klarna er en utenlandsk enhet.",
								"NL": "Verifiser at MVA-nummeret er aktivert for grensekryssende transaksjoner. Dette er nødvendig selv om du kun omsetter i ditt lokale land, da Klarna er en utenlandsk enhet. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Du kan kontakte ditt lokale skattekontor for å be om en gratis VIES-aktivering av MVA-nummeret ditt.",
								"NO": "Vi aksepterer følgende dokumenter som firma dokumenter: firmaattest hentet fra Brønnøysundregistrene.",
								"PL": "Vi aksepterer følgende dokumenter som forretningsdokumenter: Sertifikat for registering i bedriftsregisteret CEIDG, utdrag fra National Court Register (KRS)",
								"PT": "Vi godtar følgende dokumenter som forretningsdokumenter:  Certidão Permanente (obligatorisk), stiftelsessertifikat. For enkeltpersonforetak, registrering av selvstendig næringsdrivende (Declaração de Início de Atividade).",
								"US": "Dette er brevet mottatt fra skattemyndighetene (IRS) som tildelte deg et Arbeidsgivers ID-nummer (IRS CP575 EIN Letter). Hvis bedriften din er et enkeltpersonforetak og du sender inn med ditt SSN, oppgi i stedet en kopi av SSN-kortet ditt"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Sertifisert identifikasjonsdokument"
							},
							"subtitle": {
								"default": "Vi aksepterer følgende dokumenter: ID-kort, pass, førerkort. Dokumentene må oppfylle følgende kriterier:"
							},
							"list": [
								{
									"text": "Sertifisert av en autorisert sertifiserende embedsmann (for eksempel en notar, eidkommisær, jurist, advokat og/eller sertifisert regnskapsfører)."
								},
								{
									"text": "Signert og stemplet. Stempelet må vise synlige detaljer om sertifisøren som kan verifiseres, som for eksempel fullt navn, adresse, og der aktuelt, registreringsnummer."
								},
								{
									"text": "Datert – sertifiseringsdato ikke eldre enn 6 måneder."
								},
								{
									"text": "Attestert som en ekte kopi av en original ved å klart stadfeste at det originale dokumentet ble sett."
								}
							]
						}
					},
					"modal": {
						"title": "Hvorfor trenger vi dokumentene dine?",
						"close": "Lukk",
						"content": [
							{
								"title": "Beskrivelse av prosessen",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Krav til filer",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Hvordan skanne dokumenter?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Opplasting mislyktes",
						"too_large_file": "Filen er for stor <strong>(maks {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Du har kun tillatelse til å laste opp {number} filer.",
						"invalid_file_format": "Ugyldig filformat. De eneste aksepterte filtypene er {acceptedFileFormats}",
						"duplicate_file_name": "Duplisert filnavn. Alle opplastede filer må ha unike navn.",
						"try_again": "Prøv på nytt eller <u>velg en annen fil</u>"
					},
					"buttons": {
						"modal": "Hvorfor trenger vi dokumentene dine?",
						"next": "Neste",
						"back": "Tilbake",
						"submit": "Send inn dokumenter"
					}
				},
				"document_upload_success": {
					"title": "Opplasting fullført.",
					"message": "Takk! Dokumentene dine er lastet opp."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Kan du oppgi registreringsnummeret?",
							"AT": "Kan du oppgi registreringsnummeret?",
							"CA": "Kan du skrive inn ditt føderale BN?",
							"GR": "Kan du angi G.E.MI.-nummeret ditt (Γ.Ε.ΜΗ.)?",
							"NZ": "Kan du oppgi bedriftsnummeret ditt?"
						},
						"managed": {
							"default": "Kan du oppgi selskapets registreringsnummer?",
							"AT": "Kan du oppgi selskapets registreringsnummer?",
							"CA": "Kan du skrive inn ditt føderale BN?",
							"GR": "Kan du angi G.E.MI.-nummeret (Γ.Ε.ΜΗ.) til selskapet?",
							"NZ": "Kan du oppgi selskapets forretningsnummer?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AT": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"CA": "Vi trenger det føderale bedriftsnummeret tildelt bedriften din av CRA (Canada Revenue Agency) for å bekrefte bedriftsdetaljene dine.",
							"GR": "Vi trenger G.E.MI.-nummeret ditt for å verifisere forretningsopplysningene.",
							"NZ": "Vi trenger bedriftsnummeret ditt for å bekrefte forretningsinformasjonen din."
						},
						"managed": {
							"default": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AT": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"CA": "Vi trenger det føderale bedriftsnummeret tildelt bedriften din av CRA (Canada Revenue Agency) for å bekrefte bedriftsdetaljene dine.",
							"GR": "Vi trenger G.E.MI.-nummeret for å verifisere forretningsopplysningene.",
							"NZ": "Vi trenger selskapets forretningsnummer for å bekrefte forretningsinformasjonen."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Vær oppmerksom på at Klarna for øyeblikket ikke kan tilby sine betalingstjenester for kanadiske enkeltpersonforetak. Hvis du fortsetter med søknaden din, vil den bli avvist."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registreringsnummer",
								"AT": "Registreringsnummer",
								"CA": "Forretningsnummer",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)",
								"NZ": "Forretningsnummer"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Hvilken skatteklassifisering har du?",
						"managed": "Kan du oppgi virksomhetens skatteklassifisering?"
					},
					"subtitle": {
						"unmanaged": "Vi vil be deg om ulike opplysninger avhengig av selskapets juridiske status.",
						"managed": "Vi ber deg om forskjellige opplysninger, avhengig av selskapets juridiske status."
					},
					"info": {
						"unmanaged": "Du finner bedriftens EIN (Arbeidsgivers identifikasjonsnummer) på selvangivelser, kredittrapporter, lønnsslipper eller lisenser og tillatelser",
						"managed": "Du finner bedriftens EIN (Arbeidsgivers identifikasjonsnummer) på selvangivelser, kredittrapporter, lønnsslipper eller lisenser og tillatelser"
					},
					"fields": {
						"registration_number": {
							"label": "Arbeidsgivers identifikasjonsnummer",
							"errors": {
								"general": "Oppgi et gyldig Arbeidsgiversidentifikasjonsnummer",
								"invalid": "Arbeidsgivers identifikasjonsnummer bør være 9 sifre med en \"-\" etter de to første. F.eks.: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Federal Tax Classification",
								"managed": "Bedriftstype"
							},
							"errors": {
								"is_one_of": "Velg en av de oppførte virksomhetstypene"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Kan du oppgi momsnummeret?",
							"AU": "Kan du oppgi ABN?",
							"ES": "Hva er skatte-ID-nummeret ditt?",
							"NZ": "Kan du oppgi GST-nummeret ditt?"
						},
						"managed": {
							"default": "Kan du oppgi momsnummeret?",
							"AU": "Kan du oppgi ABN?",
							"ES": "Hva er skatte-ID-nummeret ditt?",
							"NZ": "Kan du oppgi GST-nummeret?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Med momsnummeret kan vi lettere bekrefte informasjon om virksomheten.",
							"AU": "Med ABN kan vi lettere bekrefte informasjon om virksomheten.",
							"NZ": "Med GST-nummeret kan vi lettere bekrefte informasjon om virksomheten.",
							"ES": "Med NIF-, NIE- eller DNI-nummeret kan vi lettere bekrefte informasjon om virksomheten."
						},
						"managed": {
							"default": "Vi bruker momsnummeret for å verifisere virksomhetens informasjon.",
							"AU": "Vi bruker ABN for å verifisere virksomhetens informasjon.",
							"NZ": "Vi bruker GST-nummeret for å verifisere virksomhetens informasjon.",
							"ES": "Vi bruker NIF-, NIE- eller DNI-nummeret for å verifisere bedriftens informasjon."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "MVA-nummer",
								"AU": "ABN",
								"NZ": "GST-nummer",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Hva slags virksomhet har du?",
						"managed": "Hva slags virksomhet er dette?"
					},
					"subtitle": {
						"unmanaged": "Det er obligatorisk at vi stiller noen spesifikke spørsmål basert på virksomhetstypen.",
						"managed": "Det er obligatorisk at vi stiller noen spesifikke spørsmål basert på denne virksomhetstypen."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Rettslig beskrivelse",
							"errors": {
								"is_one_of": "Velg en av de oppførte virksomhetstypene"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Er virksomheten registrert?",
							"AU": "Har virksomheten en ACN?",
							"ES": "Er bedriften din i Registro Mercantil?"
						},
						"managed": {
							"default": "Er denne virksomheten registrert?",
							"AU": "Har denne virksomheten en ACN?",
							"ES": "Er bedriften din i Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AT": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AU": "Hvis du har en ACN, vennligst skriv den inn, ellers velger du nei og fortsetter.",
							"ES": "Svar Ja hvis du er en SL, SA, SCP, ... osv. Svar Nei hvis du er en selvstendig næringsdrivende, frilanser, ... osv",
							"GB": "Vi trenger virksomhetens organisasjonsnummer for å bekrefte forretningsopplysningene.",
							"GR": "Vi trenger G.E.MI.-nummeret ditt for å verifisere forretningsopplysningene."
						},
						"managed": {
							"default": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AT": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AU": "Hvis virksomheten har en ACN, vennligst oppgi dette, ellers velger du nei og fortsetter.",
							"ES": "Svar Ja hvis du er en SL, SA, SCP, ... osv. Svar Nei hvis du er en selvstendig næringsdrivende, frilanser, ... osv",
							"GB": "Vi trenger virksomhetens organisasjonsnummer for å bekrefte forretningsopplysningene.",
							"GR": "Vi trenger selskapets G.E.MI.-nummer for å verifisere forretningsopplysningene."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Vennligst legg inn registreringsnummeret",
							"AT": "Vennligst legg inn registreringsnummeret",
							"AU": "Oppgi ACN",
							"ES": "Skriv inn firmaets NIF/NIE/DNI",
							"GB": "Oppgi organisasjonsnummeret",
							"GR": "Angi G.E.MI.-nummeret ditt (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Oppgi registreringsnummeret",
							"AT": "Oppgi registreringsnummeret",
							"AU": "Oppgi ACN",
							"ES": "Skriv inn firmaets NIF/NIE/DNI",
							"GB": "Oppgi organisasjonsnummeret",
							"GR": "Angi G.E.MI.-nummeret (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registreringsnummer",
								"AT": "Registreringsnummer",
								"AU": "Australsk firmanummer (ACN)",
								"ES": "Firma-NIF/NIE/DNI",
								"GB": "Organisasjonsnummer",
								"GR": "G.E.MI.-nummer (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"mid-selector": {
					"title": "Velg en butikk",
					"subtitle": "Denne e-postadressen er tilknyttet flere butikker. Velg en butikk for å fortsette.",
					"mid-selector": "Selger-ID / butikknavn",
					"buttons": {
						"next": "Fortsett"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Er virksomheten registrert?",
						"managed": "Er denne virksomheten registrert?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AT": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene."
						},
						"managed": {
							"default": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene.",
							"AT": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Vennligst legg inn registreringsnummeret",
							"AT": "Vennligst legg inn registreringsnummeret"
						},
						"managed": {
							"default": "Oppgi registreringsnummeret",
							"AT": "Oppgi registreringsnummeret"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registreringsnummer",
								"AT": "Registreringsnummer"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Er virksomheten momsregistrert?",
							"ES": "Har bedriften din et NIF/NIE/DNI?",
							"NZ": "Er bedriften registrert for GST?"
						},
						"managed": {
							"default": "Er denne virksomheten momsregistrert?",
							"ES": "Har bedriften din et NIF/NIE/DNI?",
							"NZ": "Er bedriften registrert for GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Hvis du har et momsnummer, kan vi lettere bekrefte informasjon om virksomheten.",
							"ES": "Hvis bedriften din har et NIF/NIE/DNI-nummer, kan vi lettere bekrefte informasjon om virksomheten.",
							"NZ": "Har du et GST-nummer, får vi enklere bekreftet informasjon om bedriften."
						},
						"managed": {
							"default": "Vi bruker momsnummeret for å verifisere virksomhetens informasjon.",
							"ES": "Hvis bedriften din har et NIF/NIE/DNI-nummer, kan vi lettere bekrefte informasjon om virksomheten.",
							"NZ": "Vi bruker GST-nummeret for å verifisere bedriftens informasjon."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Vennligst oppgi MVA-registrering",
							"ES": "Skriv inn firmaets NIF/NIE/DNI",
							"NZ": "Skriv inn GST-nummeret"
						},
						"managed": {
							"default": "Oppgi MVA-nummeret",
							"ES": "Skriv inn firmaets NIF/NIE/DNI",
							"NZ": "Skriv inn GST-nummeret"
						}
					},
					"vat_id": {
						"label": {
							"default": "MVA-nummer",
							"ES": "Firma-NIF/NIE/DNI",
							"NZ": "GST-nummer"
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Er virksomheten momsregistrert?",
						"managed": "Er denne virksomheten momsregistrert?"
					},
					"subtitle": {
						"unmanaged": "Hvis du har et momsnummer, kan vi lettere bekrefte informasjon om virksomheten.",
						"managed": "Vi bruker momsnummeret for å verifisere virksomhetens informasjon."
					},
					"form_title": {
						"unmanaged": "Vennligst oppgi MVA-registrering",
						"managed": "Oppgi MVA-nummeret"
					},
					"vat_id": {
						"label": {
							"default": "MVA-nummer",
							"NZ": "GST-nummer"
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Hva er forretningsadressen?",
						"managed": "Hva er virksomhetens forretningsadresse?"
					},
					"subtitle": {
						"unmanaged": "Vi må vite hvor virksomheten ligger.",
						"managed": "Vi må vite hvor denne virksomheten ligger."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					},
					"fields": {
						"partnership_name": {
							"label": "Partnerskapets navn",
							"errors": {
								"general": "Oppgi et partnerskapsnavn"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Vennligst oppgi en gyldig adresse"
							}
						},
						"postal_code": {
							"label": "Postnummer",
							"errors": {
								"general": "Oppgi et gyldig postnummer"
							}
						},
						"city": {
							"label": "By/sted",
							"errors": {
								"general": "Oppgi en gyldig by"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Oppgi et gyldig land"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Hvem eier virksomheten?",
						"GB": "Hvem leder denne virksomheten?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi er lovpålagt av EUs direktiv om bekjempelse av hvitvasking ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						],
						"AU": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						]
					},
					"infobox": "Vennligst skriv inn personlig informasjon og bostedsadresse til alle partnere og ledere som utøver kontroll over selskapets ledelse.",
					"buttons": {
						"add_person": "+ Legg til person",
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"payouts_summary": {
					"title": "Bankkontoer",
					"default_bank_accounts": {
						"no_elements": "Ingen standard bankkonto tilgjengelig"
					},
					"additional_bank_accounts": {
						"no_elements": "Du sendte ikke inn noen ekstra bankkontoer"
					}
				},
				"pre_assessment_company_details": {
					"title": "Vennligst oppgi mer informasjon om muligheter.",
					"subtitle": "Gi oss en andel av kortvolumet og opplysningene om virksomheten til denne forhandleren. Oppgi også om virksomheten opererer fra et annet marked enn det registrerte landet, da dette er obligatorisk for risikovurderingen.",
					"fields": {
						"volume_by_card": {
							"label": "Andel kortvolum av totalvolum (%)",
							"errors": {
								"invalid": "Kortvolumet skal være et tall mellom 0 og 100",
								"invalid_hint": "Legg til volumet av korttransaksjoner fra det totale Klarna-volumet for denne muligheten. Oppgi 0 % hvis muligheten ikke har noen kortbetalinger"
							}
						},
						"average_order_value": {
							"label": "Gjennomsnittlig ordreverdi (i SEK)",
							"tooltip": "Bør være et positivt beløp i SEK",
							"errors": {
								"invalid": "Bør være et positivt beløp i SEK"
							}
						},
						"registration_country": {
							"label": "Registreringsland",
							"errors": {
								"required": "Registreringsland er obligatorisk"
							}
						},
						"operating_country": {
							"label": "Driftsland",
							"errors": {
								"required": "Driftsland er obligatorisk"
							}
						},
						"registration_number": {
							"label": {
								"default": "Registreringsnummer (påkrevd for registrerte selskaper)",
								"AU": "ACN (påkrevd for registrerte selskaper)",
								"ES": "Firma NIF/NIE/DNI (påkrevd for registrerte selskaper)",
								"GR": "G.E.MI. nummer (Γ.Ε.ΜΗ.) (påkrevd for registrerte selskaper)",
								"NZ": "Bedriftsnummer (påkrevd for registrerte selskaper)",
								"US": "TIN/EIN (påkrevd for registrerte selskaper)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Oppgi ACN eller ABN",
								"invalid": "ABN bør bestå av 11 sifre"
							}
						},
						"registration_authority": {
							"label": "Registreringsmyndighet",
							"errors": {
								"required": "Velg registreringsmyndighet"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "Selgers e-post",
							"errors": {
								"invalid": "Vennligst skriv inn en gyldig e-postadresse"
							}
						},
						"store_url": {
							"label": "Butikkens nettadresse",
							"errors": {
								"required": "Butikkens nettadresse er obligatorisk",
								"invalid": "Vennligst legg inn en gyldig nettsideadresse"
							}
						},
						"goods_category": {
							"label": "Hovedkategori av varesalg",
							"errors": {
								"invalid": "Du må velge ett av alternativene"
							}
						},
						"is_managed": {
							"label": "Skal et administrert innlegg publiseres?"
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"pre_assessment_products": {
					"title": "Oppgi alle produktene",
					"subtitle": "På grunn av risikovurderingen er det obligatorisk at det informeres om alle produkter per salgsland",
					"select": {
						"label": "Søk produkt"
					},
					"selected": {
						"label": "Valgte produkter:"
					},
					"clear": "Fjern alt",
					"errors": {
						"invalid": "Velg minst ett produkt per land"
					},
					"channels": {
						"ONLINE": "På nett",
						"IN_STORE": "I butikk",
						"TELESALES": "Telefonsalg",
						"SELLER_APP": "Selger-appen"
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"wrong_prefill_data": {
					"title": "Ugyldige data er oppgitt",
					"subtitle": "Ugyldig eller inkompatibel forhåndsutfylt informasjon levert av SalesForce.",
					"details": "Detaljer: ",
					"fields": {
						"goodsCategory": "Varekategori",
						"paymentInterval": "Betalingsintervall",
						"paymentDelay": "Betalingsforsinkelse",
						"registrationCountry": "Registreringsland",
						"storeUrl": "Butikkens nettadresse",
						"mainSellingCountry": "Hovedland for salg",
						"products": "Produkter",
						"products_item": "Produkt {index}",
						"products_item_yearlyAcquiredVolume": "Produkt {index} årlig anskaffet volum",
						"products_item_sellingCountry": "Produkt {index} salgland",
						"products_item_productName": "Produkt {index} navn",
						"products_item_channels": "Produkt{index}kanaler",
						"products_item_channels_item": "Produkt{index}kanal"
					},
					"error_types": {
						"fallback": "er ugyldig",
						"any": {
							"required": "er obligatorisk, og ingen ble gitt"
						}
					}
				},
				"selling_countries": {
					"title": "Oppgi alle salgsland",
					"subtitle": "Den komplette listen over land er obligatorisk for risikovurdering",
					"select": {
						"label": "Søk etter land"
					},
					"selected": {
						"label": "Valgte land:"
					},
					"fields": {
						"selling_countries": {
							"label": "Velg land",
							"errors": {
								"invalid": "Du må velge minst ett land"
							}
						}
					},
					"clear": "Fjern alt",
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"main_selling_country": {
					"title": "Hvilket er det viktigste Klarna-markedet for forhandleren?",
					"subtitle": "Velg markedet med det høyeste forventede Klarna-volumet",
					"errors": {
						"invalid": "Du må velge et land"
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"fca_number": {
					"title": "Oppgi FCA-nummeret",
					"subtitle": "Vi er juridisk pålagt å verifisere lisensen til kredittmegleren.",
					"fields": {
						"fca_number": {
							"label": "FCA-nummer",
							"errors": {
								"general": "Oppgi et gyldig FCA nummer"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"sole_trader": {
					"title": "Hvem eier virksomheten?",
					"subtitle": {
						"default": [
							{
								"text": "Vi er lovpålagt av EUs direktiv om bekjempelse av hvitvasking ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						]
					},
					"infobox": {
						"unmanaged": "Vennligst skriv inn din personlige informasjon og boligadresse.",
						"managed": "Vennligst skriv inn eierens informasjon og bostedsadresse."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Personen som sender inn søknaden er den samme som enkeltmannsforetaket",
							"error": "Du kan bare fortsette hvis du sender inn søknaden som enkeltmannsforetak."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Driver du fra en annen adresse?",
								"managed": "Drives denne virksomheten fra en annen adresse?"
							},
							"subtitle": {
								"unmanaged": "Bare velg ja hvis du driver virksomheten fra en annen adresse enn bostedsadressen.",
								"managed": "Bare velg ja hvis denne virksomheten driver fra en annen adresse enn en bostedsadresse for enkeltmannsfortaket."
							}
						},
						"title": "Oppgi virksomhetens adresse",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Vennligst oppgi gyldig adresse"
								}
							},
							"postal_code": {
								"label": "Postnummer",
								"errors": {
									"general": "Oppgi et gyldig postnummer"
								}
							},
							"city": {
								"label": "By/sted",
								"errors": {
									"general": "Oppgi en gyldig by"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Vennligst oppgi gyldig land"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Kan du bekrefte to ting til?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Du er den eneste forhandleren",
							"label": "Personen som sender inn søknaden er den samme som enkeltmannsforetaket"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Bare du har økonomisk kontroll",
							"label": "Eieren er den eneste personen som har økonomisk kontroll over bedriftens bankkonto(er)"
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					},
					"robot_message": "Beklager, men vi må bekrefte disse to tingene"
				},
				"underwriting_info": {
					"title": "Oppgi volum og betalingsforsinkelse for muligheten",
					"subtitle": "Oppgi det samlede forventede årlige Klarna-volumet for denne muligheten, for alle markeder og betalingsforsinkelsen. Hvis betalingsforsinkelsen er forskjellig fra land til land, bruk den for det valgte hovedlandet for salg.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Totalt årlig markedsvolum (i SEK)",
							"errors": {
								"invalid": "Totalt årlig markedsvolum skal være et positivt beløp i SEK",
								"too_long": "Totalt årlig markedsvolum kan ikke bestå av mer enn 16 sifre"
							}
						},
						"payment_delay": {
							"label": "Betalingsforsinkelse",
							"errors": {
								"general": "Oppgi en verdi for betalingsforsinkelse",
								"invalid": "Betalingsforsinkelsen bør være et tall mellom {min} og {max}"
							}
						},
						"payment_interval": {
							"label": "Betalingsintervall",
							"errors": {
								"invalid": "Du må velge ett av alternativene"
							}
						},
						"volume_by_card": {
							"label": "Andel av kasse (%)",
							"errors": {
								"invalid": "Andel av kasse skal være et tall mellom 0 og 100",
								"invalid_hint": "Legg til volumet av korttransaksjoner fra det totale Klarna-volumet for denne muligheten. Oppgi 0 % hvis muligheten ikke har noen kortbetalinger"
							}
						},
						"average_order_value": {
							"label": "Gjennomsnittlig ordreverdi (i SEK)"
						}
					},
					"buttons": {
						"back": "Tilbake",
						"next": "Neste"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Hva er butikkinformasjonen din?"
						},
						"managed": "Hva er butikkinformasjonen?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Vi bruker informasjonen til å opprette bedriftskontoen din.",
							"default": "Vi vil bruke de oppgitte detaljene som din primære kontaktinformasjon og for å se på butikken."
						},
						"managed": "Vi vil bruke de oppgitte detaljene som den primære kontaktinformasjonen og for å se på denne butikken."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Merkenavn / DBA",
								"MX": "Merkenavn / DBA",
								"US": "Merkenavn / DBA",
								"default": "Butikknavn"
							},
							"errors": {
								"required": "Butikknavn er påkrevd",
								"required_us": "Merkenavn / DBA er obligatorisk",
								"invalid": "Oppgi et butikknavn på minimum 2 tegn",
								"invalid_us": "Oppgi et merkenavn / DBA på minimum 2 tegn",
								"invalid_characters": "Butikknavnet kan ikke inneholde følgende tegn: < >",
								"invalid_characters_us": "Merkenavnet / DBA kan ikke inneholde følgende tegn: < >"
							}
						},
						"website": {
							"label": "Nettbutikkside",
							"errors": {
								"required": "Nettsted er påkrevd",
								"invalid": "Vennligst legg inn en gyldig nettsideadresse"
							}
						},
						"goods_category": {
							"label": "Hovedkategori av varesalg",
							"errors": {
								"required": "Varekategori er obligatorisk"
							}
						},
						"email": {
							"label": "E-post til kundestøtte",
							"errors": {
								"required": "Kundestøtte-e-post er obligatorisk",
								"invalid": "Vennligst skriv inn en gyldig e-postadresse"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Endre produkter"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Hva er den registrerte forretningsadresse?",
						"managed": "Hva er den registrerte forretningsadressen til virksomheten?"
					},
					"subtitle": {
						"unmanaged": "Vi må vite hvilken adresse virksomheten er registrert på.",
						"managed": "Vi må vite hvilken adresse denne virksomheten er registrert på."
					},
					"question": {
						"title": {
							"unmanaged": "Driver du fra en annen adresse?",
							"managed": "Drives denne virksomheten fra en annen adresse?"
						},
						"subtitle": {
							"unmanaged": "Bare velg ja hvis denne virksomheten driver fra en annen adresse enn den registrerte.",
							"managed": "Bare velg ja hvis denne virksomheten driver fra en annen adresse enn den som er registrert."
						}
					},
					"toggle": {
						"title": "Legg til adressen til hovedstedet for virksomheten"
					},
					"fields": {
						"company_name": {
							"label": "Selskapets juridiske navn",
							"errors": {
								"general": "Vennligst oppgi firmanavn"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Vennligst oppgi adresse"
							}
						},
						"postal_code": {
							"label": "Postnummer",
							"errors": {
								"general": "Vennligst oppgi postnummer"
							}
						},
						"city": {
							"label": "By/sted",
							"errors": {
								"general": "Vennligst oppgi by/sted"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Vennligst oppgi land"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					},
					"messages": {
						"lookup": "Er dette din virksomhet? Se over og bekreft om det er riktig."
					}
				},
				"uk_sole_trader": {
					"title": "Hvem eier denne virksomheten?",
					"subtitle": {
						"unmanaged": "Du er i ferd med å inngå en kontrakt med Klarna. Derfor må vi hente inn personlig informasjon fra deg.",
						"managed": "Vi er pålagt å hente inn og bekrefte eierens personlige informasjon."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Driver du fra en annen adresse?",
								"managed": "Drives denne virksomheten fra en annen adresse?"
							},
							"subtitle": {
								"unmanaged": "Bare velg ja hvis du driver virksomheten fra en annen adresse enn bostedsadressen.",
								"managed": "Bare velg ja hvis denne virksomheten driver fra en annen adresse enn en bostedsadresse for enkeltmannsfortaket."
							}
						},
						"title": "Oppgi virksomhetens adresse",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Vennligst oppgi gyldig adresse"
								}
							},
							"postal_code": {
								"label": "Postnummer",
								"errors": {
									"general": "Oppgi et gyldig postnummer"
								}
							},
							"city": {
								"label": "By/sted",
								"errors": {
									"general": "Oppgi en gyldig by"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Vennligst oppgi gyldig land"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Hvem eier virksomheten?",
					"subtitle": {
						"default": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
					},
					"infobox": {
						"unmanaged": "Vennligst skriv inn din personlige informasjon og boligadresse.",
						"managed": "Vennligst skriv inn eierens informasjon og bostedsadresse."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Driver du fra en annen adresse?",
								"managed": "Drives denne virksomheten fra en annen adresse?"
							},
							"subtitle": {
								"unmanaged": "Bare velg ja hvis du driver virksomheten fra en annen adresse enn bostedsadressen.",
								"managed": "Bare velg ja hvis denne virksomheten driver fra en annen adresse enn en bostedsadresse for enkeltmannsfortaket."
							}
						},
						"title": "Oppgi virksomhetens adresse",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Vennligst oppgi gyldig adresse"
								}
							},
							"postal_code": {
								"label": "Postnummer",
								"errors": {
									"general": "Oppgi et gyldig postnummer"
								}
							},
							"city": {
								"label": "By/sted",
								"errors": {
									"general": "Oppgi en gyldig by"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Vennligst oppgi gyldig land"
								}
							},
							"region": {
								"label": "Delstat",
								"errors": {
									"general": "Oppgi en stat"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Er det noen personer som eier mer enn 25 % av denne virksomheten?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"default": [
							{
								"text": "Vi er nødt til å kjenne til personene som eier mer enn 25 % av aksjene eller stemmerettighetene i denne virksomheten, eller utøver lignende kontroll. Vi er juridisk pålagt å følge EUs direktiv om hvitvasking av penger ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						]
					},
					"infobox": {
						"default": "Vennligst skriv inn individets personlige informasjon og boligadresse.",
						"AU": "Vennligst skriv inn den enkeltes personlige informasjon og boligadresse. Dette må være fysiske personer for selskaper med komplekse eierstrukturer."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake",
						"add_person": "+ Legg til person"
					},
					"messages": {
						"lookup": "Eier disse personene mer enn 25 % av virksomheten? Se over og bekreft om det er riktig."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Hva er forretningsadressen din?",
						"managed": "Hva er den registrerte forretningsadressen til virksomheten?"
					},
					"subtitle": {
						"unmanaged": "Dette er stedet virksomheten din er lovlig registrert, og vil vises på Klarna-kunders fakturaer.",
						"managed": "Vi må vite hvilken adresse denne virksomheten er registrert på."
					},
					"question": {
						"title": {
							"unmanaged": "Driver du fra en annen adresse?",
							"managed": "Drives denne virksomheten fra en annen adresse?"
						},
						"subtitle": {
							"unmanaged": "Bare velg ja hvis du driver virksomheten fra en annen adresse enn den registrerte.",
							"managed": "Bare velg ja hvis denne virksomheten driver fra en annen adresse enn den som er registrert."
						}
					},
					"toggle": {
						"title": "Legg til adressen til hovedstedet for virksomheten"
					},
					"fields": {
						"company_name": {
							"label": "Registrerte virksomhetsnavn",
							"errors": {
								"general": "Vennligst oppgi firmanavn"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Vennligst oppgi adresse"
							}
						},
						"postal_code": {
							"label": "Postnummer",
							"errors": {
								"general": "Vennligst oppgi postnummer"
							}
						},
						"city": {
							"label": "By/sted",
							"errors": {
								"general": "Vennligst oppgi by/sted"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Vennligst oppgi land"
							}
						},
						"state_of_incorporation": {
							"label": "Innlemmet stat",
							"errors": {
								"general": "Oppgi en innlemmet stat"
							}
						},
						"state": {
							"label": "Delstat",
							"errors": {
								"general": "Oppgi en stat"
							}
						},
						"region": {
							"label": "Region",
							"errors": {
								"puerto_rico": "Puerto Rico ikke tillatt"
							}
						}
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"select_products": {
					"title": "Våre tjenester",
					"title_kco_hidden": "Betalingsmetoder som øker salget.",
					"subtitle": "Velg tjenestene som interesserer deg.",
					"subtitle_kco_hidden": "Lås opp kundens kjøpekraft. Tilby flere betalingsalternativer slik at de kan bestemme når og hvordan de skal betale.",
					"platform_alert": null,
					"buttons": {
						"next": "Neste"
					}
				},
				"signup_products": {
					"title_line_1": "Klarna-produkter til din butikk.",
					"title_kco_hidden_line_1": "Betalingsmetoder som",
					"title_kco_hidden_line_2": "øker salget.",
					"subtitle": "Å tilby Klarnas betalingsmetoder fører til en gjennomsnittlig økning på 30 % i konvertering, 41 % i AOV og 36 % i kjøpsfrekvens.",
					"subtitle_kco_hidden": "Lås opp kundens kjøpekraft. Tilby flere betalingsalternativer slik at de kan bestemme når og hvordan de skal betale.",
					"info_block": "Viser tilgjengelige produkter for",
					"special_offer": "Spesialtilbud: {percentageFee} % + {fixedFee} per transaksjon. Gyldig til og med {validUntil}.",
					"buttons": {
						"contact_sales": "Kontakt salg",
						"next": "Opprett konto",
						"back": "Tilbake"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Tilbake",
						"next": "Neste"
					}
				},
				"business_concepts": {
					"title": "Velg gjeldende forretningskonsepter.",
					"subtitle": "Velg bare de som gjelder. Dette kan være flere.",
					"errors": {
						"select_at_least_one": "Velg minst ett forretningskonsept."
					},
					"buttons": {
						"next": "Neste",
						"back": "Tilbake"
					}
				},
				"confirm_copy": {
					"title": "Bekreft kopi",
					"disclaimer": "All eksisterende informasjon i gjeldende MID blir overskrevet med data fra",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Ikke kopier",
						"confirmCopy": "Kopier data"
					}
				},
				"pre_assessment_summary": {
					"title": "Oppsummering",
					"subtitle": "Vennligst gå gjennom dataene nøye før du sender dem til underskrift",
					"banner": {
						"mcc_deal": "Dette er en MCC-avtale. Følg opptrappingsrutinen for MCC / ECC"
					},
					"selling_countries": {
						"title": "Velg markedet med det høyeste forventede volumet.",
						"main_selling_country": "Hovedland for salg"
					},
					"pre_assessment_products": {
						"title": "Produkter"
					},
					"company_details": {
						"title": "Bedriftsinformasjon"
					},
					"fca_number": {
						"title": "FCA-nummer"
					},
					"high_exposure_questionnaires": {
						"title": "Spørreskjema for høy eksponering"
					},
					"mia_questionnaires": {
						"title": "MIA-spørreskjemaer"
					},
					"buttons": {
						"back": "Tilbake",
						"edit": "Endre",
						"submit": "Send inn"
					}
				},
				"pre_assessment_overview": {
					"title": "Oversikt forhåndsvurderinger",
					"subtitle_APPROVED": "Du finner de godkjente vilkårene for denne muligheten nedenfor.",
					"subtitle_REJECTED": "Du finner de avviste vilkårene for denne muligheten nedenfor.",
					"subtitle_UNRESOLVED": "Du kan endre den innsendte informasjonen i tilfelle du oppdager feil. Dette utløser ikke en ny sak.",
					"status": {
						"APPROVED": "Saken ble godkjent",
						"REJECTED": "Saken ble avvist",
						"UNRESOLVED": "Venter på undertegningsvedtak ...",
						"UNRESOLVED_TIMED_OUT": "Saken vil gå gjennom manuell undertegning. Vær oppmerksom på at dette kan ta flere dager.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Se sak i Merchant Review GUI",
						"STARTED": "Saken blir sendt til vurdering"
					},
					"buttons": {
						"change": "Endre",
						"new_case": "Ny sak"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Hei!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Klarna er et regulert selskap under tilsyn av det svenske finanstilsynet, og er juridisk pålagt å forhindre hvitvasking av penger, som beskrevet i EU-direktivet EU 2015/849 (som endret eller erstattet). For deg som forhandler betyr direktivet at Klarna samler inn informasjon om personene som kontrollerer virksomheten (fordelaktige eiere) før du kan begynne å bruke Klarnas tjenester. Eksisterende forhandlere skal oppgi denne informasjonen regelmessig for å sikre at den er oppdatert. Du finner mer informasjon i EU-direktivet "
							},
							{
								"text": "her",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Neste"
					}
				},
				"recollection_confirmation": {
					"title": "Bekreftelse",
					"subtitle": "Vennligst gå gjennom dataene nøye før du sender dem til underskrift",
					"stakeholder": "Interessent {index}",
					"buttons": {
						"back": "Tilbake",
						"submit": "Send inn"
					}
				},
				"recollection_overview": {
					"title": "Takk!",
					"subtitle": "Her er en oversikt over informasjonen du sendte inn.",
					"stakeholder": "Interessent {index}",
					"notice": "Informasjonen er sendt."
				},
				"volume_separation": {
					"title_line_1": "Hvor stor er nettvirksomheten din?",
					"subtitle": "Klarna er utstyrt med de beste løsningene som passer din virksomhet - uansett hvor stor eller liten.",
					"selector_title": "Årlig omsetning",
					"below": "Under {threshold}",
					"between": "Mellom {belowThreshold} og {aboveThreshold}",
					"over": "Over {threshold}",
					"buttons": {
						"back": "Tilbake"
					}
				},
				"basic_info": {
					"title_line_1": "Få Klarna",
					"title_line_2": "for din bedrift.",
					"subtitle": "Vi trenger litt grunnleggende informasjon for å få deg til rett sted.",
					"fields": {
						"email": {
							"label": "E-post til arbeid",
							"field_link": "Er du ikke en bedrift?",
							"errors": {
								"required": "E-post er påkrevd",
								"invalid": "Vennligst skriv inn en gyldig e-postadresse"
							}
						},
						"email_confirmation": {
							"label": "Bekreft e-post til arbeid",
							"tooltip": "E-posten til arbeid blir et viktig kontaktpunkt for kommunikasjon med Klarna. Pass på at den er riktig.",
							"errors": {
								"required": "Bekreftelse av e-post er obligatorisk",
								"invalid": "Pass på at du oppgir samme e-post to ganger"
							}
						},
						"website": {
							"label": "Nettbutikkens URL",
							"errors": {
								"required": "Nettbutikkens URL er påkrevd",
								"invalid": "Oppgi en gyldig url"
							}
						},
						"country": {
							"label": "Registreringsland",
							"errors": {
								"general": "Vennligst velg tilgjengelige land"
							}
						}
					},
					"buttons": {
						"continue": "Fortsett"
					}
				},
				"contact_details": {
					"title_line_1": "La oss ta en prat.",
					"subtitle": "Fyll ut dette skjemaet, så kontakter vi deg med skreddersydde løsninger for din virksomhet.",
					"fields": {
						"full_name": {
							"label": "Fullt navn",
							"errors": {
								"required": "Fullt navn er påkrevd"
							}
						},
						"phone": {
							"label": "Telefonnummer",
							"tooltip": "Du må inkludere landskoden, f.eks. +1 541 754 3010",
							"errors": {
								"required": "Telefonnummer er påkrevd",
								"invalid": "Ugyldig telefonnummer"
							}
						},
						"tell_us_more": {
							"label": "Fortell oss litt mer om bedriften din (valgfritt)"
						}
					},
					"buttons": {
						"back": "Tilbake",
						"submit": "Send kontaktinformasjon"
					}
				},
				"contact_received": {
					"title": "Vi snakkes snart!",
					"message_1": "Vårt salgsteam tar kontakt med deg så fort som mulig.",
					"message_2": "Teamet vårt vil ta kontakt så raskt som mulig. Vi har også sendt en bekreftelse på informasjonen du sendte til"
				},
				"we_are_sorry": {
					"title": "Beklager, vi kan dessverre ikke godta søknaden deres for øyeblikket.",
					"message_1_unsupported_country": "Klarna støtter for øyeblikket ikke landet du har valgt:",
					"message_1_sensitive_goods": "Klarna støtter ikke den valgte produktkategorien:",
					"message_1_platform": "Klarna støtter for øyeblikket ikke den valgte e-handelsplattformen:",
					"message_2": "Vi jobber kontinuerlig med å danne nye samarbeid, og vil kontakte dere så snart det er mulig å fortsette med søknaden deres.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Du kan fortsatt bruke"
							},
							{
								"text": "pluginen",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "fra vår partner Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Hvilken plattform bruker du?",
					"subtitle": "Velg din e-handelsplattform, så integrerer vi virksomheten din på kort tid.",
					"custom": "Egenbygd integrasjon",
					"other_platform": "Andre integrasjonsløsninger",
					"platform_search": {
						"label": "E-handelsplattform",
						"no_match": "Vi fikk ingen treff på \"{input}\""
					},
					"buttons": {
						"back": "Tilbake"
					}
				},
				"partner": {
					"title_line_1": "Hvilken betalingstjenestepartner vil du onboarde med?",
					"subtitle": "Velg betalingstjenestepartneren som passer best for dine behov."
				},
				"account_creation_loading": {
					"title": "Setter opp konto...",
					"message": "Skaper butikk-ID..."
				},
				"application_checking": {
					"title": "Sjekker søknaden din...",
					"message": "Analyserer butikk-data"
				},
				"application_review": {
					"title": "Vi går gjennom søknaden din.",
					"title_approved": "Søknaden din ble godkjent!",
					"message": "Dette er en manuell prosess, så håndteringstiden kan variere, men vi skal bli ferdige så fort vi kan.",
					"email_info_1": "Vi har sendt deg en e-post med emnelinjen \"{subject}\".",
					"email_info_2": "Følg trinnene der for å logge inn og spore statusen på søknaden din.",
					"email_info_2_approved": "Følg trinnene der for å logge inn og integrere Klarna i din nettbutikk.",
					"email_subject": "Velkommen til Klarna's Merchant Portal",
					"resend_email": "Send e-post på nytt"
				},
				"user_already_exists": {
					"title": "Logg inn på Merchant Portal for å fortsette.",
					"message_1": "Denne e-postadressen er allerede tilknyttet en Merchant Portal-konto. For å gjøre endringer i den eksisterende kontoen, vennligst logg inn",
					"log_in": "Logg inn på Merchant Portal",
					"forgot_password": "Glemt passordet?"
				},
				"otherPlatform": {
					"info": "Vi har allerede en integrasjon for {platform}",
					"link": "Start integreringen her",
					"title": "Smoooth, du kan integrere direkte!",
					"info2": "Gode nyheter! Du kan integrere Klarna i nettbutikken din direkte fra <strong>{platform}</strong>.",
					"link2": "Gå til {platform} + Klarna Integration"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Vennligst ta direkte kontakt med salgsteamet vårt",
							"SE": "Vennligst ta direkte kontakt med salgsteamet på"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Tilbyr du noen av de følgende produktene eller tjenestene?",
					"subtitle_2": "Klarna kan definere enkelte elementer som begrenset basert på marked, lover, salgsvolum, risikoappetitt og andre begrensninger som kan være tillatt, og ikke skal behandles uten Klarnas godkjenning.",
					"titleV2": "Velg hvilke nedenfor som gjelder for din virksomhet.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Aldersbegrensede produkter",
							"description_2": "Tobakk, e-sigaretter, vape, cannabis-produkter, alkohol, voksent innhold"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Reiser, omvisninger og arrangementer",
							"description_2": "Transport, arrangementer, billettplattformer, hoteller eller overnatting, utleie, turbyråer"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Lisensierte våpen",
							"description_2": "Ammunisjon, kampkniver, jaktutstyr, batonger, pepperspray"
						},
						"MARKETPLACE": {
							"title_2": "Markedsplass for kollegaer",
							"description_2": "Tjenester som tillater tredjeparter å selge varene sine eller tilby tjenester via sin plattform på nett"
						},
						"PHARMACEUTICALS": {
							"title_2": "Farmakologiske og medisinske tjenester",
							"description_2": "Distribusjon av reseptbelagte legemidler, medisinske prosedyrer inkludert estetikk og tatoveringer"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Medlemskap, abonnementer og tjenester",
							"description_2": "Abonnement på fysiske varer, digitalt innhold, strømmetjenester, datingnettsteder osv."
						},
						"NONE": {
							"title_2": "Jeg tilbyr en annen type produkt/tjeneste"
						}
					},
					"link": "Mer om begrensede elementer",
					"buttons": {
						"next": "Neste",
						"continue": "Fortsett"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Skriv inn postnummeret ditt for å fylle ut andre deler av adressen automatisk",
						"US": "Skriv inn postnummeret ditt for å fylle ut andre deler av adressen automatisk"
					},
					"label": {
						"default": "Postnummer",
						"US": "Postnummer"
					},
					"error": {
						"default": "Oppgi et gyldig postnummer",
						"US": "Oppgi et gyldig postnummer"
					}
				},
				"city": {
					"label": "By/sted",
					"error": "Oppgi en by"
				},
				"street": {
					"label": "Adresse",
					"error": "Oppgi en adresse",
					"tooltip": "Begynn å skrive for å se flere gateforslag",
					"no_suggestion_found": "Ingen treff for {input}"
				},
				"country": {
					"label": "Land",
					"error": "Vennligst velg land"
				},
				"region": {
					"label": "Stat / region (valgfritt)"
				},
				"state": {
					"label": "Delstat",
					"error": "Oppgi en stat"
				}
			},
			"platforms": {
				"custom": "API-integrasjon",
				"other": "Jeg finner ikke plattformen min"
			},
			"buttons": {
				"back": "Tilbake"
			},
			"products": {
				"not_available": "Ikke tilgjengelig på {reason}",
				"not_available_country": "Ikke tilgjengelig i ditt land",
				"not_available_platform": "Ikke tilgjengelig på {plattform}",
				"why_product": "Hvorfor Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Kasse"
					},
					"description": {
						"default": "Bytt ut utsjekkingen i butikken din med Klarnas komplette utsjekkingstjenester."
					},
					"description_expanded": {
						"default": "Bytt ut utsjekkingen i butikken din med Klarnas komplette utsjekkingstjenester."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Betal nå"
							},
							"description": {
								"default": "Tilby øyeblikkelig betaling med kort eller bankoverføring."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Betal innen 30 dager"
							},
							"description": {
								"default": "Tilby 30 dagers betalingsfrist. Ingen renter."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Finansiering"
							},
							"description": {
								"default": "Tilby betaling over 6-36 måneder.",
								"DE": "Tilby betaling over 6-24 måneder",
								"AT": "Tilby betaling over 6-24 måneder."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Avdrag"
							},
							"description": {
								"default": "Tilby 3 rentefrie avdrag.",
								"GB": "Tilby 3 rentefrie avdrag."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Del det i 4",
								"US": "Avdrag",
								"AU": "Betal i 4"
							},
							"description": {
								"default": "Tilby 4 rentefrie avdrag.",
								"GB": "Tilby 4 rentefrie avdrag."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Andre betalingsalternativer"
							},
							"description": {
								"default": "Kredittkort, debetkort og mer"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Meldinger på siden"
							}
						},
						"billing": {
							"name": {
								"default": "Automatisk identifikasjon og fakturering"
							}
						},
						"shipping": {
							"name": {
								"default": "Personlige fraktalternativer"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Support etter kjøp"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Betalingsmetode"
					},
					"description": {
						"default": "Legg til Klarna-betalingsmetoder i din eksisterende utsjekking"
					},
					"description_expanded": {
						"default": "Å tilby Klarnas betalingsmetoder fører til en gjennomsnittlig økning på 30 % i konvertering, 41 % i AOV og 36 % i kjøpsfrekvens."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Betal nå"
							},
							"description": {
								"default": "Tilby øyeblikkelig betaling med kort eller bankoverføring."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Betal innen 30 dager"
							},
							"description": {
								"default": "Kunder betaler 30 dager etter kjøpet, uten renter."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Finansiering"
							},
							"description": {
								"default": "Kunder kan betale om 6–36 måneder.",
								"DE": "Kunder kan betale om 6–24 måneder",
								"AT": "Kunder kan betale om 6–24 måneder."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Avdrag"
							},
							"description": {
								"default": "Tilby 3 rentefrie avdrag.",
								"GB": "Tilby 3 rentefrie avdrag."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Del det i 4",
								"US": "4 betalinger",
								"CA": "4 betalinger",
								"AU": "Betal i 4"
							},
							"description": {
								"default": "Tilby 4 rentefrie avdrag.",
								"GB": "Tilby 4 rentefrie avdrag.",
								"US": "Ordre mellom 35 $ og 1000 $ kan deles i 4 rentefrie betalinger som vil forfalle annenhver uke.",
								"CA": "Ordrer fra USD 35 opptil USD 1000 kan fordeles mellom 4 rentefrie betalinger, med betalingsfrist hver 2 uke."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Betal med kort"
							},
							"description": {
								"default": "Tilby øyeblikkelig betaling med kort eller bankoverføring."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Hvordan planlegger du å selge?",
					"options": {
						"IN_STORE": "Fysisk butikk",
						"TELESALES": "Telefonsalg"
					},
					"description": {
						"IN_STORE": "Salg skjer i hovedsak personlig og kunden får varene med en gang.",
						"TELESALES": "Salg skjer primært over telefon fra innkommende kundeanrop. Kunden får ikke varene med en gang."
					}
				},
				"country": {
					"label": "Land"
				},
				"organization_category": {
					"label": "Type juridisk enhet",
					"options": {
						"SOLE_TRADER": "Eneste forhandler",
						"PARTNERSHIP": "Partnerskap",
						"UNDEFINED": "UDEFINERT",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C selskap",
						"S_CORP": "S selskap",
						"TRUST_ESTATE": "Trust/eiendom",
						"INDIVIDUAL": "Individuell",
						"SOLE_PROPRIETORSHIP": "Enkeltpersonsforetak",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Enkeltpersonsaksjeselskap",
						"LIMITED_LIABILITY_COMPANY": "Aksjeselskap",
						"PUBLIC_LISTED_COMPANY": "Offisielt oppførte selskaper",
						"PRIVATE_COMPANY": "PRIVATE_COMPANY"
					}
				},
				"store_category": {
					"label": "Hovedkategori av varesalg",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Klær og sko: sko og klær til voksne",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Bilprodukter: bildeler og tilbehør",
						"BAGS_AND_WALLETS": "Smykker og tilbehør: vesker og lommebøker",
						"BODY_AND_HAIR_CARE": "Helse og skjønnhet: kropp- og hårpleie",
						"BOOK_AND_MAGAZINES": "Underholdning: bøker og blader",
						"CANDY": "Mat og drikke: godteri",
						"CAR_ELECTRONICS": "Elektronikk: bilelektronikk",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Barneprodukter: barneklær og pleieprodukter",
						"CHILDREN_TOYS": "Barneprodukter: barneleker",
						"CLEANING_AND_SANITARY": "Hjem og hage: rengjøring og sanitær",
						"COLLECTIBLES": "Fritid, sport og hobby: samleobjekter",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Fritid, sport og hobby: konseptbutikker og diverse",
						"COSMETICS": "Helse og skjønnhet: kosmetikk",
						"COSTUMES_AND_PARTY_SUPPLIES": "Fritid, sport og hobby: kostymer og festartikler",
						"DATING_SERVICES": "Immaterielle produkter: datingtjenester",
						"DECORATION_AND_ART": "Hjem og hage: dekorasjon og kunst",
						"DIETARY_SUPPLEMENTS": "Helse og skjønnhet: kosttilskudd",
						"DIGITAL_SERVICES": "Immaterielle produkter: digitale tjenester",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Barneprodukter: diverse barneprodukter",
						"DIVERSIFIED_ELECTRONICS": "Elektronikk: diverse",
						"DIVERSIFIED_ENTERTAINMENT": "Underholdning: diverse underholdning",
						"DIVERSIFIED_EROTIC_MATERIAL": "Erotiske materialer: diverse erotiske materialer",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Helse og skjønnhet: Diverse helse- og skjønnhetsprodukter",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Hjem og hage: diverse produkter til hjem og hage",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Smykker og tilbehør: diverse smykker og tilbehør",
						"EDUCATION": "Immaterielle produkter: utdanning",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronikk: elektronisk utstyr og tilbehør",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotiske materialer: erotiske klær og tilbehør",
						"EVENT_TICKETS": "Immaterielle produkter: billetter til arrangementer",
						"FOOD_AND_BEVERAGE": "Mat og drikke: mat og drikke",
						"FRAGRANCES": "Helse og skjønnhet: dufter",
						"FURNITURE": "Hjem og hage: møbler",
						"GENERAL_SHOES_AND_CLOTHING": "Klær og sko: generelle sko og klær",
						"HOBBY_ARTICLES": "Fritid, sport og hobby: hobbyartikler",
						"HOUSEHOLD_ELECTRONICS": "Elektronikk: husholdningselektronikk",
						"JEWELRY_AND_WATCHES": "Smykker og tilbehør: smykker og klokker",
						"KITCHENWARE": "Hjem og hage: kjøkkenutstyr",
						"MARKETPLACES": "Immaterielle produkter: markedsplasser",
						"MUSIC_AND_MOVIES": "Underholdning: musikk og film",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Fritid, sport og hobby: musikkinstrumenter og utstyr",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Smykker og tilbehør: solbriller og linser uten resept",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronikk: kontormaskiner og tilbehør",
						"OTHER_SERVICES": "Immaterielle produkter: andre tjenester",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Helse og skjønnhet: personlig pleie og forbedring av kropp",
						"PET_SUPPLIES": "Hjem og hage: kjæledyrutstyr",
						"PHARMACEUTICAL_PRODUCTS": "Helse og skjønnhet: farmasøytiske produkter",
						"PLANTS_AND_FLOWERS": "Hjem og hage: planter og blomster",
						"PRESCRIPTION_OPTICS": "Helse og skjønnhet: reseptbelagte optikk",
						"PRINTS_AND_PHOTOS": "Fritid, sport og hobby: utskrifter og bilder",
						"SAFETY_PRODUCTS": "Hjem og hage: sikkerhetsprodukter",
						"SEX_TOYS": "Erotiske materialer: sexleketøy",
						"SPORTS_GEAR_AND_OUTDOOR": "Fritid, sport og hobby: sportsutstyr og utendørs",
						"TOBACCO": "Mat og drikke: tobakk",
						"TOOLS_AND_HOME_IMPROVEMENT": "Hjem og hage: verktøy og oppussing",
						"TRAVEL_SERVICES": "Immaterielle produkter: reisetjenester",
						"UNDERWEAR": "Klær og sko: undertøy",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Underholdning: dataspill og tilbehør",
						"WHEELS_AND_TIRES": "Bilprodukter: dekk og felg",
						"WINE_BEER_AND_LIQUOR": "Mat og drikke: vin, øl og sprit",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Klær og sko: sko og klær til ungdom"
					}
				},
				"currency": {
					"label": "Valuta"
				},
				"account_type": {
					"label": "Bankkontotype",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Lokalt i Sverige",
						"LOCAL_US": "Lokalt i USA",
						"LOCAL_GENERIC": "Lokalt i Norge/Danmark",
						"SPECIAL": "Spesiell",
						"BANKGIRO": "Lokal svensk bankgiro",
						"PLUSGIRO": "Lokal svensk plusgiro"
					}
				},
				"person_role": {
					"label": "Rolle",
					"options": {
						"LEGAL_REPRESENTATIVE": "Juridisk representant",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Alternativ rettighetsinnehaver",
						"ULTIMATE_BENEFICIAL_OWNER": "Endelig rettighetsinnehaver",
						"OWNER": "Eier"
					}
				},
				"business_size": {
					"label": "Bedriftsstørrelse",
					"options": {
						"LARGE": "stor",
						"MEDIUM": "medium",
						"small": "liten"
					}
				},
				"sensitive_good_category": {
					"label": "Tilbyr du noen av de følgende produktene eller tjenestene i din fysiske butikk?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Aldersbegrensede produkter",
						"LICENSED_WEAPONS": "Lisensierte våpen",
						"PHARMA_AND_MEDICAL_SERVICES": "Farmakologiske og medisinske tjenester",
						"TRAVEL_TOURS_EVENTS": "Reiser, omvisninger og arrangementer",
						"PEER_TO_PEER_MARKETPLACE": "Markedsplass for kollegaer",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Medlemskap, abonnementer og tjenester",
						"NONE": "Jeg tilbyr en annen type produkt/tjeneste"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tobakk, e-sigaretter, vape, cannabis-produkter, alkohol, voksent innhold",
						"LICENSED_WEAPONS": "Ammunisjon, kampkniver, jaktutstyr, batonger, pepperspray",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribusjon av reseptbelagte legemidler, medisinske prosedyrer inkludert estetikk og tatoveringer",
						"TRAVEL_TOURS_EVENTS": "Transport, arrangementer, billettplattformer, hoteller eller overnatting, utleie, turbyråer",
						"PEER_TO_PEER_MARKETPLACE": "Tjenester som tillater tredjeparter å selge varene sine eller tilby tjenester via sin plattform på nett",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Abonnement på fysiske varer, digitalt innhold, strømmetjenester, datingnettsteder osv.",
						"NONE": "Jeg tilbyr en annen type produkt/tjeneste"
					},
					"error_message": "Vi beklager. Vi kan ikke fortsette med søknaden din, da vi for øyeblikket ikke støtter typen produkt eller tjenester du har valgt."
				}
			},
			"common": {
				"country": {
					"label": "Land"
				},
				"address": {
					"city": {
						"label": "By/sted"
					},
					"postal_code": {
						"label": "Postnummer"
					},
					"region": {
						"label": "Stat / region"
					},
					"street_address": {
						"label": "Fysisk butikkadresse"
					},
					"street_address2": {
						"label": "Adresselinje 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Virksomhetens navn"
					},
					"registration_authority": {
						"label": "Registreringsmyndighet"
					},
					"registration_id": {
						"label": "Registreringsnummer"
					},
					"subject_to_vat": {
						"label": "Er virksomheten momsregistrert?"
					},
					"vat_id": {
						"label": "MVA-nummer"
					},
					"persons": {
						"date_of_birth": {
							"label": "Fødselsdato"
						},
						"first_name": {
							"label": "Fornavn"
						},
						"last_name": {
							"label": "Etternavn"
						},
						"person_identity_document": {
							"label": "Identitetsdokument"
						},
						"person_proof_of_address": {
							"label": "Adressebevis"
						},
						"personal_identifier": {
							"label": "Personlig ID"
						}
					},
					"should_auto_capture_orders": {
						"label": "Vil du registrere levere ordre automatisk?",
						"tooltip": "Ordre skal merkes som levert når de overleveres i butikk eller når de sendes fra et lager. Ved å velge autolevering vil  ordren automatisk markeres som levert når forbrukeren bekrefter kjøpet."
					}
				},
				"contract_entity": {
					"label": "Kontraktsenhet"
				},
				"contract_onboarding_type": {
					"label": "Type onboarding av forretningspartner "
				},
				"underwriting_inquiry_email": {
					"label": "E-post for underwriting"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Navn på kontoinnehaver"
					},
					"account_number": {
						"label": "Kontonummer"
					},
					"bic": {
						"label": "BIC-kode"
					},
					"iban": {
						"label": "Kontonummer (IBAN)"
					},
					"is_default": {
						"label": "Bruk denne kontoen for uspesifiserte valutaer"
					},
					"routing_number": {
						"label": "Rutingnummer"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "E-post for kontakt"
					},
					"name": {
						"label": "Butikknavn"
					},
					"support_email": {
						"label": "E-post til kundestøtte"
					},
					"support_phone": {
						"label": "Telefonnummer til support"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Vanlig varesalg",
							"VOUCHER": "Kupong",
							"MEMBERSHIP": "Medlemskap",
							"SUBSCRIPTION": "Abonnement",
							"PHARMACIES": "Apotek",
							"US_PHARMACIES": "Amerikanske apotek",
							"MEDICAL_SERVICES": "Medisinske tjenester",
							"MARKETPLACES": "Markedsplasser",
							"FIREARM_DEALERS": "Skytevåpenforhandlere",
							"AUCTIONS": "Auksjoner",
							"ALCOHOL": "Alkohol",
							"TOBACCO": "Tobakk",
							"HEMP_CBD_THC": "Hamp, CBD, eller THC",
							"DONATIONS_CHARITY": "Donasjoner og veldedighet",
							"TRAVEL": "Reise",
							"EVENTS": "Arrangementer",
							"COURSES": "Kurs",
							"EDUCATIONAL_COURSES": "Utdanningskurs",
							"FOOD_DELIVERY": "Matlevering",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Tilpasset forhåndsbestilling/møbler",
							"DIGITAL_CONTENT": "Digitalt innhold",
							"GAMING_INDUSTRY": "Spillindustri (gambling, tipping, kasinoer, lotteri)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Vilkår",
					"UPSELL_WEBSTORE_TO_KPOS": "Vilkår for Klarna In-store"
				},
				"pricing_terms": {
					"default": "Prisbetingelser",
					"UPSELL_WEBSTORE_TO_KPOS": "Priser for Klarna In-store"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Ytterligere informasjon",
				"bank_account": "Hva er kontoinformasjonen din?",
				"business_size": "Hva er ditt forventede årlige volum gjennom Klarna Point of Sale?",
				"in_store_get_started": "Få virksomheten din i gang med Klarna.",
				"in_store_legal_form": "Hva slags virksomhet har du?",
				"in_store_registered_address": "Hva er din registrerte adresse?",
				"in_store_registration": "Er virksomheten registrert?",
				"in_store_stakeholder": "Hvem leder denne virksomheten?",
				"in_store_stores": "Hva er butikkdetaljene dine for Klarna Point of Sale?",
				"in_store_vat": "Er virksomheten momsregistrert?",
				"product_channel": "Hvordan planlegger virksomheten din å bruke Klarna Point of Sale?",
				"sensitive_goods": "Hvilken produktkategori vil du selge med Klarna Point of Sale.",
				"ads_manager_get_started": "Snart ferdig.",
				"content_store_get_started": "Snart ferdig."
			},
			"subtitle": {
				"additional_data": "Vi vurderer søknaden din og trenger litt mer informasjon før vi går videre.",
				"bank_account": "Transaksjoner fra Klarna vil bli overført til denne bankkontoen.",
				"business_size": "Vi trenger litt grunnleggende informasjon om virksomheten for å behandle søknaden din.",
				"in_store_get_started": "Vi trenger litt grunnleggende informasjon for å sende deg til riktig sted",
				"in_store_legal_form": "Det er obligatorisk at vi stiller noen spesifikke spørsmål basert på virksomhetstypen.",
				"in_store_registered_address": "Det er her virksomheten din er lovlig registrert, og dette vil fremgå av dine klarna-kundefakturaer.",
				"in_store_registration": "Vi trenger virksomhetens registreringsnummer for å bekrefte forretningsopplysningene dine.",
				"in_store_stakeholder": "Som en finansinstitusjon er vi pålagt å samle inn denne informasjonen",
				"in_store_stores": "Vi bruker informasjonen til å sette opp din nye Klarna Point of Sale-konto.",
				"in_store_vat": "Hvis du har et momsnummer, kan vi lettere bekrefte informasjon om virksomheten.",
				"product_channel": "Velg din primære salgskanal. Du vil kunne bruke Klarna Point of Sale for begge kanaler.",
				"sensitive_goods": "Selvbetjent onboarding for Klarna Point of Sale tillater ikke å selge varer som er definert av Klarna som begrenset.",
				"ads_manager_get_started": "Vennligst oppgi en fakturerings-e-post som kampanjefakturaer vil bli sendt til. Du må være en admin-bruker for å aktivere kontoen. Admin kan deretter gi tillatelser til andre brukere.",
				"content_store_get_started": "Før du får tilgang til Content Manager, må du lese og godta våre vilkår og betingelser."
			},
			"summary": {
				"title": "Se gjennom informasjonen din før du sender inn søknaden"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Vi behandler søknaden din. Dette kan ta et øyeblikk.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vennligst vent...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vennligst vent..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Søknaden din blir behandlet, og vi oppretter din nye forhandler-ID."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Vi gjør alt klart for Ads Manager-kontoen din."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Vi gjør alt klart for Content Manager-kontoen din."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Gratulerer! Søknaden din har blitt godkjent.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Du er klar!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Du er klar!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "La oss nå integrere Klarna i nettbutikken din. Gå til fanen Produkter i Forhandlerportal-kontoen din for å finne integreringslegitimasjonen og instruksjoner om hvordan du bruker dem."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "La oss sette opp butikken din slik at du kan begynne å motta betalinger med en gang."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Gå over til Ads Manager for å begynne å lage din første kampanje."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Gå til Content Manager og publiser ditt første tilbud i dag."
							}
						]
					},
					"second_title": {
						"default": "Besøk Klarna-dokument for mer informasjon om hvordan du integrerer deg med Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Trenger du hjelp til å sette opp butikken din? Vi er her for å hjelpe deg",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Trenger du hjelp med å bruke Ads Manager? Sjekk ut våre vanlige spørsmål eller ta kontakt med vår forretningsstøtte, vi hjelper deg gjerne.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Trenger du hjelp til å bruke Content Manager? Sjekk ut våre vanlige spørsmål eller ta kontakt med vår forretningsstøtte, vi hjelper deg gjerne."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Våre retningslinjer for beste praksis kan hjelpe deg til å få mest mulig ut av ditt nye partnerskap med oss."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Ta kontakt med vår Forhandlersupport, vi hjelper deg gjerne."
							},
							{
								"text": "Kontakt support",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Gå til vanlige spørsmål.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Gå til vanlige spørsmål.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "La oss komme i gang.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "La oss komme i gang",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "La oss komme i gang",
						"UPSELL_WEBSTORE_TO_KPOS": "Begynn å selge"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Takk! Vi vurderer søknaden din.",
					"badge": "Cirka 5-7 dager",
					"paragraphs": [
						{
							"text": "Du vil motta en e-post når vurderingen er fullført eller hvis vi trenger mer informasjon."
						}
					],
					"second_title": "Sjekk e-posten din i mellomtiden",
					"second_paragraphs": [
						{
							"text": "Vi har sendt deg en e-post med emnelenken «Velkommen til Klarnas Forhandlerportal». Følg trinnene der for å logge deg inn og aktivere kontoen din."
						}
					]
				},
				"SUSPENDED": {
					"title": "Søknaden din ble dessverre ikke godkjent.",
					"paragraphs": [
						{
							"text": "Etter å ha gjennomgått forretningsdetaljene dine kan vi ikke gå videre med søknaden din for <strong>{businessName}</strong>."
						},
						{
							"text": "Dette er noen av de vanligste grunnene:"
						},
						{
							"list": [
								{
									"text": "Butikken din overholder ikke de etiske retningslinjene til Klarna."
								},
								{
									"text": "Din kundeservice er utilgjengelig."
								},
								{
									"text": "Andre administrative faktorer."
								}
							]
						},
						{
							"text": "Takk for din interesse for <strong>Klarna [In-store]</strong> vi håper vi kan gjøre forretninger i fremtiden."
						}
					],
					"second_title": "Hvis du har flere spørsmål",
					"second_paragraphs": [
						{
							"text": "Angående vår beslutning eller om andre Klarna-produkter er det bare å ta kontakt, vi hjelper deg gjerne."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Hvem signerer kontraktene for selskapet ditt?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Virksomheten din er i ferd med å inngå en kontrakt med Klarna. Vi må verifisere hvem som er lovlig autorisert til å signere kontrakter."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Er det noen personer som eier mer enn 25 % av denne virksomheten?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"default": [
							{
								"text": "Vi er nødt til å kjenne til personene som eier mer enn 25 % av aksjene eller stemmerettighetene i denne virksomheten, eller utøver lignende kontroll. Vi er juridisk pålagt å følge EUs direktiv om hvitvasking av penger ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Hvem leder denne virksomheten?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Vi er lovpålagt av EUs direktiv om bekjempelse av hvitvasking ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						],
						"US": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"CA": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"AU": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Er det noen personer som eier mer enn 25 % av denne virksomheten?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Som finansinstitusjon er vi juridisk pålagt å samle inn denne informasjonen."
							}
						],
						"default": [
							{
								"text": "Vi er nødt til å kjenne til personene som eier mer enn 25 % av aksjene eller stemmerettighetene i denne virksomheten, eller utøver lignende kontroll. Vi er juridisk pålagt å følge EUs direktiv om hvitvasking av penger ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") til å samle inn denne informasjonen."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Løsninger",
					"title_2": "Betalingsmetoder",
					"note": "Alle priser gjelder per transaksjon.",
					"per_transaction": "per transaksjon",
					"cross_border_notice": "Ekstra gebyr for utenlandske betalinger kan gjelde",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "se",
						"link_text": "prisvedlegg"
					},
					"not_available_for_business": "Ikke tilgjengelig for din bedrift",
					"not_available_for_country": "Du kan kun selge til andre markeder",
					"not_compatible_with_platform": "Ikke tilgjengelig for plattformen",
					"installed": "Installert"
				},
				"buttons": {
					"next": "Neste"
				}
			}
		}
	}
};